<template>
  <div class="pb_content" style="background: #f0f2f5;" v-loading="loading">
    <div class="pb_content_body" style="position: relative; margin: 0">
      <div class="right">
        <div class="courseTop">
          <div class="stepsNav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{
    path:
      '/test?userid=' +
      userid +
      '&oid=' +
      oid +
      '&org=' +
      org +
      '&role=' +
      role,
  }">表单管理</el-breadcrumb-item>
              <el-breadcrumb-item>
                <span style="color: rgb(15, 126, 255)">查看表单</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div v-if="!peopleId" class="r_pub_button_retrun" @click="retrunCourse">返回</div>
        </div>
        <div class="step_box" ref="stepBox" v-loading="pdfLoading">
          <div class="boxSticky" ref="boxSticky">
            <div class="test_title" :style="!isDesktop?'justify-content: center;':''">
              <div class="left">
                <div class="title">{{ testJson.title }}</div>
                <div class="info"  v-if="isDesktop">
                  <div class="info_box" v-if="testJson.typeN">
                    <span>类型：</span>
                    <span>{{ testJson.typeN }}</span>
                  </div>
                  <div class="info_box">
                    <span>填写范围：</span>
                    <span>{{ testJson.juriP ? testJson.juriP : '所有人' }}</span>
                  </div>
                  <div class="info_box" v-if="testJson.overtime">
                    <span>截止时间：</span>
                    <span>{{ testJson.overtime }}</span>
                  </div>
                </div>
              </div>
              <div v-if="!peopleId">
                <div class="right" v-if="isDesktop">
                  <div class="data_box">
                    <span>提交数量</span>
                    <!-- <span><span class="big">{{ works.length }}</span>份</span> -->
                    <span><span class="big">{{ worksArray.length }}</span>份</span>
                  </div>
                  <div class="data_box" v-if="testJson.juriP">
                    <span>表单完成率</span>
                    <span><span class="big">{{ (iscount / pcount * 100).toFixed(0) }}</span>%</span>
                  </div>
                  <div class="data_box" v-if="testJson.juriP">
                    <span>未完成人数</span>
                    <span><span class="big">{{ pcount - iscount }}</span></span>
                  </div>
                  <div class="btn_box" @click="dialogVisibleShare = true">
                    <span></span>
                    <span>提醒</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- pc端 查看切换 isDesktop-->
            <div class="search_nav" v-if="isDesktop">
              <div class="right">
                <span :class="{ active: stype == 1 }" @click="checkDataType(1)" v-if="!peopleId">按题目查看</span>
                <span :class="{ active: stype == 2 }" @click="checkDataType(2)">按人员查看</span>
                <span :class="{ active: stype == 3 }" @click="checkDataType(3)" v-show="false">按数量查看</span>
              </div>
              <div class="left"  v-if="isDesktop">
                <!-- <div style="margin-right: 10px;position: relative;" v-if="stype == 2 || stype == 3"> -->
                <!-- <div style="margin-right: 10px;position: relative;">
                  <el-select v-model="TeachingValue" @change="searchCourse" placeholder="按教研室">
                    <el-option
                      label="全部"
                      value="">
                    </el-option>
                    <el-option
                      v-for="item in TeachingOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div> -->
                <div style="margin-right: 10px;position: relative;" v-if="stype == 2 || stype == 3">
                  <el-date-picker
                    v-model="SubmitTime"
                    type="date"
                    @change="searchCourse"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                  <!-- <el-select v-model="SubmitTime" placeholder="按提交时间筛选">
                    <el-option
                      label="全部"
                      value="">
                    </el-option>
                    <el-option
                      v-for="item in SubmitTimeOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select> -->
                </div>
                <div style="margin-right: 10px;position: relative;" v-if="stype == 2 || stype == 3">
                  <el-input v-model="courseName" class="student_input" :disabled="!(!peopleId)" placeholder="请输入需要搜索的姓名"></el-input>
                  <span class="serach_icon" @click="searchCourse" ></span>
                </div>
                
                <div class="btnA" v-if="stype == 1 && !pdfLoading" @click="exportPDF">导出PDF</div>
                <div class="btnA" v-if="stype == 2" @mouseenter="btnDisplay = true" @mouseleave="btnDisplay = false">
                  导出数据
                  <div v-show="btnDisplay" class="buttonBox">
                    <div type="primary" @click="exportExcel">下载汇总表格</div>
                    <div type="primary" @click="exportAllWord">导出人员数据</div>
										<div type="primary" v-if="stype == 2" @click="exportWordData">word导出</div>
                  </div>
                </div>
								
                <div class="btnA" v-if="stype == 3" @click="exportAllWord2">导出人员数据</div>
                <div class="btnA" @click="openChat" v-if="this.worksArray.length && !peopleId">AI分析</div><!--v-if="this.worksArray.length"-->
								
              </div>
            </div>
             <!-- 手机端 查看切换 isDesktop-->
            <div class="search_nav" style="display:flex;justify-content:space-evenly;border: none;" v-if="!isDesktop">
              <div class="right">
                <span :class="{ active2: stype == 1 }" @click="checkDataType(1)">按题目查看</span>
                <span :class="{ active2: stype == 2 }" @click="checkDataType(2)">按人员查看</span>
                <span :class="{ active2: stype == 3 }" @click="checkDataType(3)" v-show="false">按数量查看</span>
            </div>
          </div>

          </div>


          <!-- 按题目pc端 isDesktop-->
          <div class="title_content" v-if="stype == 1 && isDesktop" v-loading="isLoading">
            <div class="title_box" v-if="!testArray.length"
              style="display: flex;align-items: center;justify-content: center;height: 500px;">
              暂无内容
            </div>
            <div class="title_box" v-for="(item, index) in testArray" :key="index">
              <div class="title">
                <el-tooltip :content="selectType(item)" placement="top" effect="dark">
                  <span class="test_icon"
                    :class="{ test_icon_check: item.type == 1 && item.atype == 2, test_icon_checkO: item.type == 1 && item.atype == 1, test_icon_gap: item.type == 3, test_icon_file: item.type == 5, test_course_file: item.type == 6 || item.type == 11, test_eva_file: item.type == 7,test_icon_time: item.type == 8 }"></span>
                </el-tooltip>
                <span style="line-height: 25px;">{{ item.title }}</span>
								<el-button v-if="item.type == 5 && item.array.length>0" class="title_downBtn" type="primary" size="small" @click.stop="downloadFileType5(item.array,item.title,index)">批量下载附件</el-button>
								<div v-if="item.type==7" style="right:0;position: absolute;">平均分：{{ getAverageScore(index) }}</div>
              </div>
              <div class="detail" v-if="item.detail">{{ item.detail }}</div>
              <div class="content1" v-if="item.type == 1">
                <div class="left">
                  <div class="title">
                    <span>选项</span>
                    <span>小计</span>
                    <span>比例</span>
                  </div>
                  <div class="data" v-for="(data, index2) in item.array" :key="index + '-' + index2">
                    <span>
                      <el-tooltip :content="data.name" placement="top" effect="dark">
                        <!-- content to trigger tooltip here -->
                        <span>{{ data.name }}</span>
                      </el-tooltip>
                    </span>
                    <span>{{ data.count }}</span>
                    <span>
                      <el-progress style="display: flex;align-items: center;" :stroke-width="12" color="#3681fc"
                        :percentage="data.count ? parseFloat(((data.count / item.count) * 100).toFixed(2)) : 0"></el-progress>
                    </span>
                  </div>
                </div>
                <div class="right">
                  <checkPie :dataJ="item.array"></checkPie>
                </div>
              </div>
              <div class="content2" v-if="item.type == 3">
                <div class="left">
                  <div class="title">
                    <span>序号</span>
                    <span>词频</span>
                    <span>答案文本</span>
                  </div>
                  <div class="data" v-for="(data, index2) in item.array" :key="index + '-' + index2">
                    <span>{{ index2 + 1 }}</span>
                    <span>{{ data.count }}次</span>
                    <el-tooltip :content="data.name" placement="top" effect="dark">
                      <!-- content to trigger tooltip here -->
                      <span>{{ data.name }}</span>
                    </el-tooltip>
                  </div>
                </div>
                <div class="right">
                  <wordcloud :data="item.array" nameKey="name" valueKey="count" :showTooltip="false"
                    :wordClick="wordClickHandler">
                  </wordcloud>
                </div>
              </div>
              <div class="content3" :style="{'position': 'relative','overflow': (fileLoading[index].bool ? 'hidden':'auto')}" v-if="item.type == 5">
                <div class="file" v-for="(file, index2) in item.array" :key="index + '-' + index2"
                  @click.stop="checkFile(file)">
                  <img class="download" src="../../../../assets/icon/fileIcon/download.png"
                    @click.stop="downloadFile(file)" :style="{ right: '10px' }" />
                  <img class="img" :src="wordIcon" alt="" v-if="file.type == 1" />
                  <img class="img" :src="videoIcon" alt="" v-if="file.type == 2" />
                  <img class="img" :src="file.url" alt="" v-if="file.type == 3" />
                  <img class="img" :src="wordIcon" alt="" v-if="file.type == 4" />
                  <img class="img" :src="fileIcon" alt="" v-if="file.type == 5" />
                  <div class="name">
                    <el-tooltip :content="file.name" placement="top" effect="dark">
                      <span>{{ file.name }}</span>
                    </el-tooltip>
                  </div>
                </div>
                <div v-if="
                    fileLoading[index].bool
                  " class="mask">
                    <div class="progressBox">
                      <div class="lbox">
                        <img src="../../../../assets/loading.gif" />打包中，请稍后
                      </div>
                      <div style="margin-bottom: 10px">
                        <span>{{
                           fileLoading[index].load
                          }}</span>
                        /
                        <span>{{
                           fileLoading[index].count
                          }}</span>
                      </div>
                      <el-progress :text-inside="true" :stroke-width="20" :percentage=" fileLoading[index].progress
                        ?  fileLoading[index].progress
                        : 0
                        " style="width: 80%"></el-progress>
                    </div>
                </div>
              </div>
              <div class="content4" v-if="item.type == 6">
                <div class="out_box" v-for="(item, index) in item.courseArray" :key="index + '-' + index2">
                  <div class="tup">
                    <img :src="item.cover != null && item.cover != ''
    ? JSON.parse(item.cover).length > 0
      ? JSON.parse(item.cover)[0].url
      : mr
    : mr
    " alt />
                    <div class="bottom_box">
                      <div>
                        <el-tooltip :content="item.title" popper-class="text_tooltip" placement="top" effect="dark">
                          <span>{{ item.title }}</span>
                        </el-tooltip>
                      </div>
                      <div class="kc_t">
                        <span>{{ item.username }}</span>
                        <span>{{ item.state == 1 ? '阶段模式' : item.state == 2 ? '任务模式' : '极简模式' }}</span>
                      </div>
                      <div class="kc_time">
                        <span style="color: #717C8D">创建日期:</span>{{ item.time }}
                      </div>
                      <div class="kc_time">
                        <span style="color: #717C8D">修改日期:</span>{{ item.update_at }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="courses" v-for="(courses, index2) in item.array" :key="index + '-' + index2">
                  {{ courses }}
                </div> -->
              </div>
              <div class="content1" v-if="item.type == 7">
                <div class="left">
                  <div class="title">
                    <span>评分</span>
                    <span>小计</span>
                    <span>比例</span>
                  </div>
                  <div class="data" v-for="(data, index2) in item.array" :key="index + '-' + index2">
                    <span>
                      <span>{{ data.name }}</span>
                    </span>
                    <span>{{ data.count }}</span>
                    <span>
                      <el-progress style="display: flex;align-items: center;" :stroke-width="12" color="#3681fc"
                        :percentage="data.count ? parseFloat(((data.count / item.count) * 100).toFixed(2)) : 0"></el-progress>
                    </span>
                  </div>
                </div>
                <div class="right">
                  <checkPie :dataJ="item.array"></checkPie>
                </div>
              </div>
              <div class="content2" v-if="item.type == 8">
                <div class="left">
                  <div class="title">
                    <span>序号</span>
                    <span>词频</span>
                    <span>日期</span>
                  </div>
                  <div class="data" v-for="(data, index2) in item.array" :key="index + '-' + index2">
                    <span>{{ index2 + 1 }}</span>
                    <span>{{ data.count }}次</span>
                    <el-tooltip :content="data.name" placement="top" effect="dark">
                      <!-- content to trigger tooltip here -->
                      <span>{{ data.name }}</span>
                    </el-tooltip>
                  </div>
                </div>
                <div class="right">
                  <wordcloud :data="item.array" nameKey="name" valueKey="count" :showTooltip="false"
                    :wordClick="wordClickHandler">
                  </wordcloud>
                </div>
              </div>
              <div class="content4" v-if="item.type == 11">
                <div class="out_box" v-for="(item, index) in item.courseArray" :key="index + '-' + index2">
                  <div class="tup">
                    <img :src="item.cover != null && item.cover != ''
    ? JSON.parse(item.cover).length > 0
      ? JSON.parse(item.cover)[0].url
      : mr
    : mr
    " alt />
                    <div class="bottom_box">
                      <div>
                        <el-tooltip :content="item.title" popper-class="text_tooltip" placement="top" effect="dark">
                          <span>{{ item.title }}</span>
                        </el-tooltip>
                      </div>
                      <div class="kc_t">
                        <span>{{ item.username }}</span>
                        <span>{{ item.state == 1 ? '阶段模式' : item.state == 2 ? '任务模式' : '极简模式' }}</span>
                      </div>
                      <div class="kc_time">
                        <span style="color: #717C8D">创建日期:</span>{{ item.time }}
                      </div>
                      <div class="kc_time">
                        <span style="color: #717C8D">修改日期:</span>{{ item.update_at }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="courses" v-for="(courses, index2) in item.array" :key="index + '-' + index2">
                  {{ courses }}
                </div> -->
              </div>
            </div>
          </div>
          <!-- 按题目手机端 !isDesktop-->
          <div class="title_content" v-if="stype == 1 && !isDesktop" v-loading="isLoading">
            <div class="title_box" v-if="!testArray.length"
              style="display: flex;align-items: center;justify-content: center;height: 500px;">
              暂无内容
            </div>
            <div class="title_box" v-for="(item, index) in testArray" :key="index">
              <div class="title" style="font-size: 16px;display: flex;justify-content: space-between;align-items: center;">
                <!-- <el-tooltip :content="selectType(item)" placement="top" effect="dark">
                  <span class="test_icon"
                    :class="{ test_icon_check: item.type == 1 && item.atype == 2, test_icon_checkO: item.type == 1 && item.atype == 1, test_icon_gap: item.type == 3, test_icon_file: item.type == 5, test_course_file: item.type == 6, test_eva_file: item.type == 7,test_icon_time: item.type == 8 }"></span>
                </el-tooltip> -->
                <div style="display: flex;">
                  <div class="topicTitCss">第{{ index+1 }}题:</div>
                  <el-tooltip :content="item.title" placement="top" effect="dark">
                    <div style="width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.title }}</div>
                  </el-tooltip>

                  
                </div>
                <div style="display: flex;">
                  <!-- <div v-if="item.type==7" style="right:0;position: absolute;">平均分：{{ getAverageScore(index) }}</div> -->
                  <div style="color: rgba(0, 0, 0, 0.4);display: flex;align-items: center;">[{{ selectType(item) }}]</div>
                  <!-- <el-button style="padding: 5px;" v-if="item.type == 5 && item.array.length>0" class="title_downBtn" type="primary" size="small" @click.stop="downloadFileType5(item.array,item.title)">批量下载附件</el-button> -->
                </div>
              </div>
              <div class="detail" v-if="item.detail">{{ item.detail }}</div>
              <div class="content1" style="width:100%;display: block;" v-if="item.type == 1">
                <div class="left" style="width:100%" v-if="!item.cut">
                  <div class="isDesktopTitle">
                    <div>选项</div>
                    <div>小计</div>
                    <div>比例</div>
                  </div>
                  <div class="isDesktopTitle" v-for="(data, index2) in item.array" :key="index + '-' + index2">
                    <!-- <span> -->
                      <el-tooltip :content="data.name" placement="top" effect="dark">
                        <!-- content to trigger tooltip here -->
                        <div>{{ data.name }}</div>
                      </el-tooltip>
                    <!-- </span> -->
                    <div>{{ data.count }}</div>
                    <div>
                      {{ data.count ? parseFloat(((data.count / item.count) * 100).toFixed(2)) : 0 }}
                       <!-- <el-progress style="display: flex;align-items: center;" :stroke-width="12" color="#3681fc"
                        :percentage="data.count ? parseFloat(((data.count / item.count) * 100).toFixed(2)) : 0"></el-progress> -->
                    </div>
                  </div>
                </div>
                <div class="right isDesktopRight" v-if="item.cut">
                  <checkPie :dataJ="item.array"></checkPie>
                </div>
                <div class="cutBtnBlockCss">
                  <div class="cutBtnCss" @click="item.cut=!item.cut">{{ item.cut?'查看详情':'查看视图' }}</div>
                </div>
              </div>
              <div class="content2"  style="width:100%;display: block;" v-if="item.type == 3">
                <div class="left" style="width:100%" v-if="!item.cut">
                  <div class="title">
                    <span>序号</span>
                    <span>词频</span>
                    <span>答案文本</span>
                  </div>
                  <div class="data" v-for="(data, index2) in item.array" :key="index + '-' + index2">
                    <span>{{ index2 + 1 }}</span>
                    <span>{{ data.count }}次</span>
                    <el-tooltip :content="data.name" placement="top" effect="dark">
                      <!-- content to trigger tooltip here -->
                      <span>{{ data.name }}</span>
                    </el-tooltip>
                  </div>
                </div>
                <div class="right isDesktopRight" v-if="item.cut">
                  <wordcloud :data="item.array" nameKey="name" valueKey="count" :showTooltip="false"
                    :wordClick="wordClickHandler">
                  </wordcloud>
                </div>
                <div class="cutBtnBlockCss">
                  <div class="cutBtnCss" @click="item.cut=!item.cut">{{ item.cut?'查看详情':'查看视图' }}</div>
                </div>
              </div>
              <div class="content3" v-if="item.type == 5">
                <div class="file" v-for="(file, index2) in item.array" :key="index + '-' + index2"
                  @click.stop="checkFile(file)">
                  <img class="download" src="../../../../assets/icon/fileIcon/download.png"
                    @click.stop="downloadFile(file)" :style="{ right: '10px' }" />
                  <img class="img" :src="wordIcon" alt="" v-if="file.type == 1" />
                  <img class="img" :src="videoIcon" alt="" v-if="file.type == 2" />
                  <img class="img" :src="file.url" alt="" v-if="file.type == 3" />
                  <img class="img" :src="wordIcon" alt="" v-if="file.type == 4" />
                  <img class="img" :src="fileIcon" alt="" v-if="file.type == 5" />
                  <div class="name">
                    <el-tooltip :content="file.name" placement="top" effect="dark">
                      <span>{{ file.name }}</span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="content4" v-if="item.type == 6">
                <div class="out_box" v-for="(item, index) in item.courseArray" :key="index + '-' + index2">
                  <div class="tup">
                    <img :src="item.cover != null && item.cover != ''
    ? JSON.parse(item.cover).length > 0
      ? JSON.parse(item.cover)[0].url
      : mr
    : mr
    " alt />
                    <div class="bottom_box">
                      <div>
                        <el-tooltip :content="item.title" popper-class="text_tooltip" placement="top" effect="dark">
                          <span>{{ item.title }}</span>
                        </el-tooltip>
                      </div>
                      <div class="kc_t">
                        <span>{{ item.username }}</span>
                        <span>{{ item.state == 1 ? '阶段模式' : item.state == 2 ? '任务模式' : '极简模式' }}</span>
                      </div>
                      <div class="kc_time">
                        <span style="color: #717C8D">创建日期:</span>{{ item.time }}
                      </div>
                      <div class="kc_time">
                        <span style="color: #717C8D">修改日期:</span>{{ item.update_at }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="courses" v-for="(courses, index2) in item.array" :key="index + '-' + index2">
                  {{ courses }}
                </div> -->
              </div>
              <div class="content1" style="width:100%;display: block;" v-if="item.type == 7">
                <div class="left" style="width:100%" v-if="!item.cut">
                  <div class="isDesktopTitle">
                    <div>评分</div>
                    <div>小计</div>
                    <div style="width: 120px;">比例</div>
                  </div>
                  <div class="isDesktopTitle" v-for="(data, index2) in item.array" :key="index + '-' + index2">
                    <!-- <span> -->
                    <div>{{ data.name }}</div>
                    <!-- </span> -->
                    <div>{{ data.count }}</div>
                    <div style="width: 120px;">
                      {{ data.count ? parseFloat(((data.count / item.count) * 100).toFixed(2)) : 0 }}
                      <!-- <el-progress style="display: flex;align-items: center;" :stroke-width="12" color="#3681fc"
                        :percentage="data.count ? parseFloat(((data.count / item.count) * 100).toFixed(2)) : 0"></el-progress> -->
                    </div>
                  </div>
                </div>
                <div class="right isDesktopRight"  v-if="item.cut">
                  <checkPie :dataJ="item.array"></checkPie>
                </div>
                <div class="cutBtnBlockCss">
                  <div class="cutBtnCss" @click="item.cut=!item.cut">{{ item.cut?'查看详情':'查看视图' }}</div>
                </div>

              </div>
              <div class="content2"  style="width:100%;display: block;" v-if="item.type == 8">
                <div class="left" style="width:100%" v-if="!item.cut">
                  <div class="title">
                    <span>序号</span>
                    <span>词频</span>
                    <span>日期</span>
                  </div>
                  <div class="data" v-for="(data, index2) in item.array" :key="index + '-' + index2">
                    <span>{{ index2 + 1 }}</span>
                    <span>{{ data.count }}次</span>
                    <el-tooltip :content="data.name" placement="top" effect="dark">
                      <!-- content to trigger tooltip here -->
                      <span>{{ data.name }}</span>
                    </el-tooltip>
                  </div>
                </div>
                <div class="right isDesktopRight" v-if="item.cut">
                  <wordcloud :data="item.array" nameKey="name" valueKey="count" :showTooltip="false"
                    :wordClick="wordClickHandler">
                  </wordcloud>
                </div>
                <div class="cutBtnBlockCss">
                  <div class="cutBtnCss" @click="item.cut=!item.cut">{{ item.cut?'查看详情':'查看视图' }}</div>
                </div>
              </div>
              <div class="content4" v-if="item.type == 11">
                <div class="out_box" v-for="(item, index) in item.courseArray" :key="index + '-' + index2">
                  <div class="tup">
                    <img :src="item.cover != null && item.cover != ''
    ? JSON.parse(item.cover).length > 0
      ? JSON.parse(item.cover)[0].url
      : mr
    : mr
    " alt />
                    <div class="bottom_box">
                      <div>
                        <el-tooltip :content="item.title" popper-class="text_tooltip" placement="top" effect="dark">
                          <span>{{ item.title }}</span>
                        </el-tooltip>
                      </div>
                      <div class="kc_t">
                        <span>{{ item.username }}</span>
                        <span>{{ item.state == 1 ? '阶段模式' : item.state == 2 ? '任务模式' : '极简模式' }}</span>
                      </div>
                      <div class="kc_time">
                        <span style="color: #717C8D">创建日期:</span>{{ item.time }}
                      </div>
                      <div class="kc_time">
                        <span style="color: #717C8D">修改日期:</span>{{ item.update_at }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="courses" v-for="(courses, index2) in item.array" :key="index + '-' + index2">
                  {{ courses }}
                </div> -->
              </div>
            </div>
          </div>
					<div class="aiBoxRight" ref="aiBoxRightDivRef" v-show="aiChatV && isDesktop" v-if="!peopleId">
						<aiBoxRight :courseId="cid" :worksArray="[{name:testJson.title,worksArray:worksArray}]" ref="aiChat"></aiBoxRight>
					</div>
          <!-- 按人员pc端 isDesktop-->
          <div class="table_content" v-if="stype == 2 && isDesktop">
            <el-table class="el-table" ref="table" :data="worksArray" border :fit="true" :key="2" v-loading="isLoading"
              style="width: 100%" :header-cell-style="{ background: '#f1f1f1', fontSize: '17px' }"
              @filter-change="handleFilterChange">
              <el-table-column fixed label="序号" width="80px" align="left">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column fixed prop="name" label="提交人" width="120px" align="left">
              </el-table-column>
              <el-table-column prop="time" label="提交时间" width="170px" align="left">
								<template slot-scope="scope">
									<span :style="`${testJson.overtime&&new Date(testJson.overtime)<new Date(scope.row.time)?'color:#d12920':''}`">{{ scope.row.time }}</span>
								</template>
              </el-table-column>
              <el-table-column v-for="(item, index) in chapters" :key="index" :label="item.json.title"
                :min-width="item.type == 5 ? 200 : 150" align="left" 
								:filters="item.type == 1 ? item.nameFilters : (item.type ==  6 || item.type ==  11)? item.nameFilters : item.type==8?getTimeFilterText(item,index):null"
                :filter-method="item.type == 1 ? (value, row) => { return filterName(value, row, index) } : (item.type == 6 || item.type == 11)?(value, row) => { return filterCourse(value, row, index)}:item.type==8?(value,row)=>{return filterTime(value,row,index)}:null"
                :filter-placement="item.type == 8 ||item.type == 1 || item.type ==6|| item.type ==11 ? filterPlacement : null">
                <template slot-scope="scope">
                  <div v-if="scope.row.array[index].type == 1" style="display: flex; flex-wrap: wrap;">
                    <span class="answer_type" v-for="(answer2, index2) in scope.row.array[index].json.answer2"
                      :key="index + '-' + index2">{{ scope.row.array[index].json.array[answer2].option }}</span>
                  </div>
                  <div v-if="scope.row.array[index].type == 3 || scope.row.array[index].type == 8" style="display: flex; flex-wrap: wrap;">
                    {{ scope.row.array[index].json.answer2 }}
                  </div>
                  <div v-if="scope.row.array[index].type == 5" style="display: flex; flex-wrap: wrap;"
                    class="table_file">
                    <div class="file" v-for="(file, index2) in scope.row.array[index].json.file"
                      :key="index + '-' + index2" @click.stop="checkFile(file)">
                      <img class="download" src="../../../../assets/icon/fileIcon/download.png"
                        @click.stop="downloadFile(file)" :style="{ right: '10px' }" />
                      <img class="img" :src="wordIcon" alt="" v-if="file.type == 1" />
                      <img class="img" :src="videoIcon" alt="" v-if="file.type == 2" />
                      <img class="img" :src="file.url" alt="" v-if="file.type == 3" />
                      <img class="img" :src="wordIcon" alt="" v-if="file.type == 4" />
                      <img class="img" :src="fileIcon" alt="" v-if="file.type == 5" />
                      <div class="name">
                        <el-tooltip :content="file.name" placement="top" effect="dark">
                          <span>{{ file.name }}</span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div v-if="scope.row.array[index].type == 6" style="display: flex; flex-wrap: wrap;">
                    {{ scope.row.array[index].json.answer2}}
                  </div>
                  <div v-if="scope.row.array[index].type == 7" style="display: flex; flex-wrap: wrap;">
                    {{ getScore(scope.row.array[index].json) }}
                  </div>
                  <div v-if="scope.row.array[index].type == 11" style="display: flex; flex-wrap: wrap;">
                    {{ scope.row.array[index].json.answer2}}
                  </div>
									<div v-if="scope.row.array[index].type == 12" style="display: flex; flex-wrap: wrap;">
                    {{ scope.row.array[index].json.answer2}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200px" fixed="right" v-if="isN!=1">

                <template slot-scope="scope">
                  <el-button @click="getTest(scope.row)" type="primary" size="small">查看</el-button>
                  <!-- <el-button @click="setWordHtml(scope.row)" type="primary" size="small">导出答题信息</el-button>
									<el-button @click="setWordTemplate(scope.row)" type="primary" size="small">word导出</el-button> -->
                  <el-button @click="deleteTest(scope.row.id)" type="primary" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 按人员手机端 !isDesktop-->
          <div class="table_content" v-if="stype == 2 && !isDesktop">

            <div v-for="(i,index) in worksArray"  :key="i.id" class="isDesktopTable_content">
              <div class="isDTitle CutCss">
                <div style="font-size: 16px;font-weight: 600;">{{ i.name }}</div>
                <div :style="'font-size: 14px'+i.cut?'color:rgba(54, 129, 252, 1)':'color: rgba(0, 0, 0, 0.6);'">{{ i.time }}</div>
                <div @click="i.cut=!i.cut">
                  <img v-if="!i.cut" src="../../../../assets/icon/fileIcon/downImg.png" alt="">
                  <img v-else src="../../../../assets/icon/fileIcon/upImg.png" alt="">
                </div>
              </div>
              <div v-if="i.cut">
                <div class="isDBri">
                  <div>序号:{{ i.time }}</div>
                  <div>提交时间:{{ i.time }}</div>
                  <div>评课人:{{ i.uteaName }}</div>
                </div>
                <div style="height: 1px;background-color: #717C8D;width: 100%;margin-bottom: 10px;"></div>
                <div>
                  <div v-for="(k,kin) in chapters" :key="k.id" class="isCTiBlc">
                    <div v-if="k.type == 1">
                      <div class="isDTitle2">
                        <div style="display: flex;justify-content: space-between;">
                          <div style="display: flex;">
                            <span class="topicTitCss">第{{kin+1}}题:</span>
                            <div class="isDTitle2JsonTit">
                              {{ k.json.title }}
                            </div>
                          </div>
                          <div style="color: rgba(0, 0, 0, 0.4);">[{{ selectType2(k.type,k.json.type) }}]</div>  
                        </div>
                        <div class="IsDAnswer">
                          <div v-for="(r, index2) in i.array[kin].json.answer2"
                          :key="index + '-' + index2">
                          {{ i.array[kin].json.array[r].option }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="k.type == 3 || k.type == 8">
                      <div class="isDTitle2">
                        <div style="display: flex;justify-content: space-between;">
                          <div style="display: flex;">
                            <span class="topicTitCss">第{{kin+1}}题:</span>
                            <div class="isDTitle2JsonTit">
                              {{ k.json.title }}
                            </div>
                          </div>
                          <div style="color: rgba(0, 0, 0, 0.4);">[{{ selectType2(k.type,k.json.type) }}]</div>
                        </div>
                        <div class="IsDAnswer">
                          {{ i.array[kin].json.answer2 }}
                        </div>
                      </div>
                    </div>
                    <div v-if="k.type == 5">
                      <div class="isDTitle2">
                        <div style="display: flex;justify-content: space-between;">
                          <div style="display: flex;">
                            <span class="topicTitCss">第{{kin+1}}题:</span>
                            <div class="isDTitle2JsonTit">
                              {{ k.json.title }}
                            </div>
                          </div>
                          <div style="color: rgba(0, 0, 0, 0.4);">[{{ selectType2(k.type,k.json.type) }}]</div>
                        </div>
                        <div class="IsDAnswer">
                          <div class="IsDFile" v-for="(file, index2) in i.array[kin].json.file"
                            :key="index + '-' + index2" @click.stop="checkFile(file)">
                            <img class="IsDownload" src="../../../../assets/icon/fileIcon/download.png"
                              @click.stop="downloadFile(file)" :style="{ right: '10px' }" />
                            <img class="IsDImg" :src="wordIcon" alt="" v-if="file.type == 1" />
                            <img class="IsDImg" :src="videoIcon" alt="" v-if="file.type == 2" />
                            <img class="IsDImg" :src="file.url" alt="" v-if="file.type == 3" />
                            <img class="IsDImg" :src="wordIcon" alt="" v-if="file.type == 4" />
                            <img class="IsDImg" :src="fileIcon" alt="" v-if="file.type == 5" />
                            <div class="name" style="height: 30px;background-color: #f9f9f9;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                              <!-- <el-tooltip :content="file.name" placement="top" effect="dark"> -->
                                {{ file.name }}
                              <!-- </el-tooltip> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="k.type.type == 6">
                      <div class="isDTitle2">
                        <div style="display: flex;justify-content: space-between;">
                          <div style="display: flex;">
                            <span class="topicTitCss">第{{kin+1}}题:</span>
                            <div class="isDTitle2JsonTit">
                              {{ k.json.title }}
                            </div>
                          </div>
                          <div style="color: rgba(0, 0, 0, 0.4);">[{{ selectType2(k.type,k.json.type) }}]</div>
                        </div>
                        <div class="IsDAnswer">
                          {{ i.array[kin].json.answer2 }}
                        </div>
                      </div>
                    </div>
                    <div v-if="k.type == 7">
                      <div class="isDTitle2">
                        <div style="display: flex;justify-content: space-between;">
                          <div style="display: flex;">
                            <span class="topicTitCss">第{{kin+1}}题:</span>
                            <div class="isDTitle2JsonTit">
                              {{ k.json.title }}
                            </div>
                          </div>
                          <div style="color: rgba(0, 0, 0, 0.4);">[{{ selectType2(k.type,k.json.type) }}]</div>
                        </div>
                        <div class="IsDAnswer">
                          {{ getScore(i.array[index].json) }}
                        </div>
                      </div>
                    </div>
                    <div v-if="k.type.type == 11">
                      <div class="isDTitle2">
                        <div style="display: flex;justify-content: space-between;">
                          <div style="display: flex;">
                            <span class="topicTitCss">第{{kin+1}}题:</span>
                            <div class="isDTitle2JsonTit">
                              {{ k.json.title }}
                            </div>
                          </div>
                          <div style="color: rgba(0, 0, 0, 0.4);">[{{ selectType2(k.type,k.json.type) }}]</div>
                        </div>
                        <div class="IsDAnswer">
                          {{ i.array[kin].json.answer2 }}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                
                <div style="width: 100%;display: flex;justify-content: end;">
                  <div @click="i.cut=!i.cut" style="display: flex;flex-direction: column;align-items: center">
                    <img src="../../../../assets/icon/fileIcon/retractImg.png" alt="">
                    <div style="color: rgba(0, 0, 0, 0.4);font-size: 16px;">收起</div>
                  </div>
                </div>
              </div>

              <div style="height: 1px;background-color: #717C8D;width: 100%;margin-bottom: 10px;"></div>

            </div>



            <!-- <el-table class="el-table" ref="table" :data="worksArray" border :fit="true" :key="2" v-loading="isLoading"
              style="width: 100%" :header-cell-style="{ background: '#f1f1f1', fontSize: '17px' }"
              @filter-change="handleFilterChange">
              <el-table-column fixed label="序号" width="80px" align="left">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column fixed prop="name" label="提交人" width="120px" align="left">
              </el-table-column>
              <el-table-column prop="time" label="提交时间" width="170px" align="left">
								<template slot-scope="scope">
									<span :style="`${testJson.overtime&&new Date(testJson.overtime)<new Date(scope.row.time)?'color:#d12920':''}`">{{ scope.row.time }}</span>
								</template>
              </el-table-column>
              <el-table-column v-for="(item, index) in chapters" :key="index" :label="item.json.title"
                :min-width="item.type == 5 ? 200 : 150" align="left" :filters="item.type == 1 ? item.nameFilters : item.type ==  6? item.nameFilters : null"
                :filter-method="item.type == 1 ? (value, row) => { return filterName(value, row, index) } : item.type == 6?(value, row) => { return filterCourse(value, row, index)}:null"
                :filter-placement="item.type == 1 || item.type ==6 ? filterPlacement : null">

                <template slot-scope="scope">
                  <div v-if="scope.row.array[index].type == 1" style="display: flex; flex-wrap: wrap;">
                    <span class="answer_type" v-for="(answer2, index2) in scope.row.array[index].json.answer2"
                      :key="index + '-' + index2">{{ scope.row.array[index].json.array[answer2].option }}</span>
                  </div>
                  <div v-if="scope.row.array[index].type == 3 || scope.row.array[index].type == 8" style="display: flex; flex-wrap: wrap;">
                    {{ scope.row.array[index].json.answer2 }}
                  </div>
                  <div v-if="scope.row.array[index].type == 5" style="display: flex; flex-wrap: wrap;"
                    class="table_file">
                    <div class="file" v-for="(file, index2) in scope.row.array[index].json.file"
                      :key="index + '-' + index2" @click.stop="checkFile(file)">
                      <img class="download" src="../../../../assets/icon/fileIcon/download.png"
                        @click.stop="downloadFile(file)" :style="{ right: '10px' }" />
                      <img class="img" :src="wordIcon" alt="" v-if="file.type == 1" />
                      <img class="img" :src="videoIcon" alt="" v-if="file.type == 2" />
                      <img class="img" :src="file.url" alt="" v-if="file.type == 3" />
                      <img class="img" :src="wordIcon" alt="" v-if="file.type == 4" />
                      <img class="img" :src="fileIcon" alt="" v-if="file.type == 5" />
                      <div class="name">
                        <el-tooltip :content="file.name" placement="top" effect="dark">
                          <span>{{ file.name }}</span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div v-if="scope.row.array[index].type == 6" style="display: flex; flex-wrap: wrap;">
                    {{ scope.row.array[index].json.answer2}}
                  </div>
                  <div v-if="scope.row.array[index].type == 7" style="display: flex; flex-wrap: wrap;">
                    {{ getScore(scope.row.array[index].json) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="300px" fixed="right" v-if="isN!=1">

                <template slot-scope="scope">
                  <el-button @click="getTest(scope.row)" type="primary" size="small">查看</el-button>
                  <el-button @click="setWordHtml(scope.row)" type="primary" size="small">导出答题信息</el-button>
                  <el-button @click="deleteTest(scope.row.id)" type="primary" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table> -->
          </div>
          <div class="table_content" v-if="stype == 3">
            <div class="student_table">
              <el-table ref="table" :data="tableData" border :fit="true" v-loading="isLoading" style="width: 100%"
                :header-cell-style="{ background: '#f1f1f1', fontSize: '17px' }" :row-class-name="tableRowClassName">
                <el-table-column prop="username" label="提交人" min-width="15" align="center">
                </el-table-column>
                <el-table-column prop="time" label="提交时间" min-width="15" align="center">
                </el-table-column>
                <el-table-column label="是否批改" min-width="15" align="center">

                  <template slot-scope="scope">
                    <div>{{ scope.row.type == 3 ? '是' : '否' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="300px"  v-if="isDesktop">

                  <template slot-scope="scope" >
                    <el-button @click="getTest(scope.row)" type="primary" size="small">查看</el-button>
                    <el-button @click="setWordHtml2(scope.row)" type="primary" size="small">导出答题信息</el-button>
                    <el-button @click="deleteTest(scope.row.id)" type="primary" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="student_page">
              <el-pagination background layout="prev, pager, next" :page-size="pageSize" :total="total"
                @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

   
    <share-box :testJson="testJson" :TeachingValue="TeachingValue" :TeachName="TeachNameCpt"   :dialogVisibleShare.sync="dialogVisibleShare"></share-box>
    <wpdf :dialogVisiblePdf.sync="dialogVisiblePdf" :url="wurl"></wpdf>
    <wVideo :dialogVisibleVideo.sync="dialogVisibleVideo" :url="wurl"></wVideo>
    <wOffice :dialogVisibleOffice.sync="dialogVisibleOffice" :url="wurl"></wOffice>

		<docxTemplateDialog ref="docxTemplateDialogRef" @changeCover="changeCover"/>
  </div>
</template>

<script>
import shareBox from '../shareBox/index.vue'
import videoIcon from '../../../../assets/icon/fileIcon/isVideo.png'
import wordIcon from '../../../../assets/icon/fileIcon/isWord.png'
import fileIcon from '../../../../assets/icon/fileIcon/word2.png'

import wVideo from "../file/wVideo.vue";
import wpdf from "../file/wPdf2.vue";
import wOffice from "../file/wOffice.vue";

import wordcloud from 'vue-wordcloud';
import checkPie from '../data/checkPie.vue';

import { downloadPDF } from '../../../tools/pdf'
import JSZip from "jszip";
import FileSaver from "file-saver";

import XLSX from "xlsx-js-style";
import aiBoxRight from './aiBoxRight.vue'

// word模板
import docxTemplateDialog from './docxTemplateDialog' 

const getFile = (url) => {
    return new Promise((resolve, reject) => {
        var credentials = {
            accessKeyId: "AKIATLPEDU37QV5CHLMH",
            secretAccessKey: "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",
        }; //秘钥形式的登录上传
        window.AWS.config.update(credentials);
        window.AWS.config.region = "cn-northwest-1"; //设置区域
        let url2 = url;
        let _url2 = "";
        if (
            url2.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
        ) {
            _url2 = url2.split(
                "https://view.officeapps.live.com/op/view.aspx?src="
            )[1];
        } else {
            _url2 = url2;
        }
        var s3 = new window.AWS.S3({ params: { Bucket: "ccrb" } });
        let name = decodeURIComponent(_url2.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1].replace(/\+/g, ' '))
        var params = {
            Bucket: "ccrb",
            Key: name
        };
        s3.getObject(params, function (err, data) {
            if (err) {
                console.log(err, err.stack)
                resolve({ data: 1 });
            } else {
                resolve({ data: data.Body });
                console.log(data);
            }          // sxuccessful response

        });
        // axios({
    });
};

export default {
  components: {
    shareBox,
    wVideo,
    wpdf,
    wOffice,
    checkPie,
    wordcloud,
    aiBoxRight,
		docxTemplateDialog
  },
  data() {
    return {
      userid: this.$route.query.userid,
      oid: this.$route.query.oid,
      org: this.$route.query.org,
      role: this.$route.query.role,
      cid: this.$route.query.cid,
      isN: this.$route.query.isN,
      peopleId: this.$route.query.peopleId,
      screenWidth: window.innerWidth,
      isDesktop: false,
      aiChatV: false,
      title: "",
      testType: [],
      see: false,
      cJson: [],
      loading: false,
      look: "",
      TeachingOptions:[],
      TeachingValue :'',
      SubmitTimeOptions: [],
      SubmitTime: '',
      tableHeight: 500,
      isLoading: false,
      pageSize: 10,
      total: 0,
      page: 1,
      tableData: [],
      testJson: {},
      works: [],
      iscount: 0,
      pcount: 0,
      stype: 1,
      courseName: "",
      dialogVisibleShare: false,
      worksArray: [],
      testArray: [],
      options2: {
        1: "选择题",
        // 2: "问答题",
        3: "问答题",
        4: "添加文档",
        5: "附件"
      },
      videoIcon: videoIcon,
      wordIcon: wordIcon,
      fileIcon: fileIcon,
      dialogVisiblePdf: false,
      dialogVisibleVideo: false,
      dialogVisibleOffice: false,
      wurl: "",
      chapters: [],
      filterPlacement: 'bottom-end',
      pdfLoading: false,
      btnDisplay: false,

      fileLoading: [],
      // fileLoadCount: [],
      // fileLoadNum: [],
      // infoprogress: [],

    };
  },
  watch: {},
  computed: {
    TeachNameCpt: function () {
        // `this` 指向 vm 实例
        return this.TeachingOptions.filter(i => {return i.id == this.TeachingValue})
    },
    // vcWords() {
    //   return function (array) {
    //     let _array = [];
    //     if (array.length) {
    //       for (var i = 0; i < array.length; i++) {
    //         _array.push(
    //           {
    //             text: array[i].name,
    //             weight: array[i].count,
    //           }
    //         )
    //       }
    //     }
    //     console.log(_array);
    //     return array.length ? _array : [];
    //   };
    // },
    getScore() {
      return function (item) {
        let array = []
        for (var i = parseInt(item.small); i <= parseInt(item.big); i++) {
          array.push(i)
        }
        return item.answer2 ? array[item.answer2] : ''
      };
    },
    selectType() {
      return function (item) {
        if (item.type == 1 && item.atype == 2) {
          return '多选题'
        } else if (item.type == 1 && item.atype == 1) {
          return '单选题'
        } else if (item.type == 3) {
          return '问答题'
        } else if (item.type == 5) {
          return '附件'
        } else if (item.type == 6 || item.type == 11) {
          return '课程'
        } else if (item.type == 7) {
          return '评分'
        } else if (item.type == 8) {
          return '日期'
        }
      };
    },
    selectType2() {
      return function (val1,val2) {
        if (val1 == 1 && val2 == 2) {
          return '多选题'
        } else if (val1 == 1 && val2 == 1) {
          return '单选题'
        } else if (val1 == 3) {
          return '问答题'
        } else if (val1 == 5) {
          return '附件'
        } else if (val1 == 6) {
          return '课程'
        } else if (val1 == 7) {
          return '评分'
        } else if (val1 == 8) {
          return '日期'
        }
      };
    },
		// 获取评分的平均分
		getAverageScore(){
			return (_index)=>{
				let _result = 0;
				let _sum = 0;
				this.worksArray.forEach(i1=>{
					_result+=i1.array[_index].json.answer2
					_sum+=1;
				})
				_result = _sum ? (_result/_sum).toFixed(2) : 0
				return _result ? _result : 0;
			}
		},
		getTimeFilterText(){
			return (item,index)=>{
				let _result = [];
				if(item.type==8){
					let array = []
					this.worksArray.forEach(i=>{
						if(i.array[index].type == 8){
							let _data = i.array[index].json.answer2;
							if(!array.map(r=>r.value).includes(_data)){
								array.push({text:_data,value:_data})
							}
						}
					})
					array.sort((a, b) =>{

						const dateA = new Date((a.value.replace(/年|月/g, '-')).replace(/日/g,""));
    				const dateB = new Date((b.value.replace(/年|月/g, '-')).replace(/日/g,""));
						return dateB - dateA; // 从小到大排序
					});

					console.log("👉排序：",array)
					_result=array;
				}
				return _result;
			}
		}
  },
  methods: {
    openChat(){
      this.aiChatV = !this.aiChatV;
      this.$nextTick(() => {
        const boxStickyHeight = this.$refs.boxSticky ? this.$refs.boxSticky.offsetHeight : 0;
        const chatHeight = `calc(100% - ${boxStickyHeight}px - 46px)`;
        // this.$refs.aiChat.$el.style.height = chatHeight;
				this.$refs.aiBoxRightDivRef.style.height = chatHeight;
      });
    },
    fileClose(done){
      done()
    },
    //获取教研室列表
    getClass2() {
      let params = {
          oid: this.oid,
      };
      this.ajax
          .get(this.$store.state.api + "selectTeacherOfficeBySchool", params)
          .then((res) => {
            console.log('this.TeachingOptions',this.TeachingOptions);
            console.log(res.data);
            let data = res.data[0];
            this.TeachingOptions.forEach(e=>{
              data.forEach(i=>{
                if (e.id == i.id) {
                  e.name = i.name
                }
              })
            })
          })
          .catch((err) => {
              this.isLoading = false;
              console.error(err);
          });
    },
    getClass3() {
      let params = {
          oid: this.oid,
      };
      this.ajax
          .get(this.$store.state.api + "selectTeacherOfficeBySchool", params)
          .then((res) => {
            console.log(res.data);
              this.TeachingOptions = res.data[0].filter(item=>{
                return item.parentid == '6'
              });
              // console.log('this.TeachingOptions',this.TeachingOptions);
          })
          .catch((err) => {
              this.isLoading = false;
              console.error(err);
          });
    },
    filterName(value, row, index) {
      let name = []
      for (var i = 0; i < row.array[index].json.answer2.length; i++) {
        name.push(row.array[index].json.array[row.array[index].json.answer2[i]].option)
      }
      console.log(name.indexOf(value) != -1);
      return name.indexOf(value) != -1;
    },
		// 筛选课程
		filterCourse(value, row, index) {
			return row.array[index].json.answer2.indexOf(value) != -1;
    },
		//筛选日期
		filterTime(value, row, index){
			return row.array[index].json.answer2.indexOf(value)!=-1;
		},
    wordClickHandler(name, value) {
      //  this.$notify({
      //   title: name,
      //   message: "数量："+value
      // });
    },
    retrunCourse() {
      this.goTo(
        "/test?userid=" +
        this.userid +
        "&oid=" +
        this.oid +
        "&org=" +
        this.org +
        "&role=" +
        this.role
      );
    },
    goTo(path) {
      this.$router.push(path);
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "even_row";
      } else {
        return "";
      }
    },
    changeHeight() {
      if (this.stype == 1) {
        return
      }
      this.tableHeight = this.$refs.stepBox.offsetHeight - 120;
      if (this.tableHeight <= 530) {
        this.tableHeight = 530;
      }
      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        if (self.stype == 1) {
          return
        }
        self.tableHeight = this.$refs.stepBox.offsetHeight - 120;
        if (self.tableHeight <= 530) {
          self.tableHeight = 530;
        }
      };
      // this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //200表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData2();
    },
    getTest(row) {
      this.$router.push(
        "/checkTest2?cid=" +
        row.courseid +
        "&userid=" +
        this.userid +
        "&userid2=" +
        row.userid +
        "&tid=" +
        row.id +
        "&oid=" +
        this.oid +
        "&org=" +
        this.org +
        "&type=2" +
        "&role=" +
        this.role
      );
    },
    checkDataType(type) {
      this.TeachingValue = ''
      if (this.stype != type) {
        this.stype = type
        this.courseName = ''
        if (type == 3) {
          this.getData2();
        } else {
          this.getData();
        }
        this.changeHeight();
      }
    },
    searchCourse() {
      if (this.stype == 3) {
        this.getData2()
      } else {
        this.getData()
      }
    },

    getData() {
      this.isLoading = true;
      let params = {
        cid: this.cid,
        cn: this.courseName,
        tim : !this.SubmitTime? '' : this.SubmitTime,
        tea: this.TeachingValue
      };
      this.ajax
        .get(this.$store.state.api + "getTestWorksNoPageCopy", params)
        .then(async (res) => {
          this.testJson = res.data[0][0]
          console.log('this.testJson',JSON.parse(JSON.stringify(this.testJson)));

          let a = ''
          if(this.testJson.juriP){
              a = this.testJson.juriP
          }
          if(this.testJson.juriP2){
              if(a){
                  a = this.testJson.juriP+','+this.testJson.juriP2
              }else {
                  a = this.testJson.juriP2
              }
          }
          this.testJson.juriP = a


          if (this.testJson.juriP) {
            let ajuri2 =  this.testJson.juri2.split (',');
            this.TeachingOptions = ajuri2.map((key, index) => ({
              id : key,
              name: ''
            }));
            this.getClass2()
          }else{
            this.getClass3()
          }

          // console.log('dddd',this.TeachingOptions);

          this.works = res.data[1]
          this.iscount = res.data[2][0].count
          this.pcount = res.data[3][0].count
          let chapters = this.setJSON(this.setJson2(JSON.parse(JSON.stringify(JSON.parse(res.data[0][0].chapters)))))
          this.chapters = this.setFilter(this.JSONSetting(JSON.parse(JSON.stringify(JSON.parse(res.data[0][0].chapters)))))
          let courseCount11 = []
          let testArray = []
          let array = []
          let courseIds = []; // 初始化一个空数组来存储所有的courseId
          for (let i = 0; i < this.works.length; i++) {
            let cJson = this.setJSON(JSON.parse(JSON.stringify(JSON.parse(this.works[i].courseJson))))
            if (JSON.stringify(cJson) == JSON.stringify(chapters)) {
              let _json = this.JSONSetting(JSON.parse(JSON.stringify(JSON.parse(this.works[i].courseJson))))

              for (var ja = 0; ja < _json.length; ja++) {
                let _json2 = _json[ja].json;
                if (_json[ja].type == 6) {
                  let courseId = _json2.answer2;
                  courseIds.push(courseId); // 将type为6的courseId添加到数组中
                }
                if (_json[ja].type == 11) {
                  let _answer = _json2.answer2;
                  _answer.length ? courseCount11 = courseCount11.concat(_answer) : '';
                  _json[ja].json.courseId = _answer ? _answer : [];
                  courseIds = courseIds.concat(_answer); // 将type为11的courseId添加到数组中
                }
              }
            }
          }

          // 将所有的courseId去重
          courseIds = Array.from(new Set(courseIds));
          // 使用一个数组来存储所有的courseId后，执行getCourseInfoTestAll
          let courseTitles = {}; // 初始化一个空对象来存储所有的courseTitles
          let params2 = [{
            cid: courseIds.join(",")
          }]

          let data2 = await this.ajax.post(this.$store.state.api + 'getCourseInfoTestAll2', params2);
          let result2 = data2.data[0];
          result2.forEach(i => {
            // _title.push(i.title);
            courseTitles[i.courseId] = i.title;
          });

          for (let i = 0; i < this.works.length; i++) {
            let cJson = this.setJSON(JSON.parse(JSON.stringify(JSON.parse(this.works[i].courseJson))))
            if (JSON.stringify(cJson) == JSON.stringify(chapters)) {
              let _json = this.JSONSetting(JSON.parse(JSON.stringify(JSON.parse(this.works[i].courseJson))))

              _json.forEach(item => {
                if (item.type == 11) {
                  let cid = item.json.answer2
                  let _title = []
                  for(var i = 0; i < cid.length; i++){
                    _title.push(courseTitles[cid[i]])
                  }
                  item.json.answer2 = _title.length ? _title.join(",") : '';
                }
                if (item.type == 6) {
                  let courseId = item.json.answer2;
                  item.json.answer2 = courseTitles[courseId] || '';
                }
              });
              // 更新对应的_json对象的answer2
              array.push({
                courseid: this.works[i].courseid,
                id: this.works[i].id,
                userid: this.works[i].userid,
                name: this.works[i].username ? this.works[i].username : '匿名',
                time: this.works[i].time,
                array: _json,
                cut:0,
                uteaName: this.works[i].uteaName,
                courseJson: JSON.parse(this.works[i].courseJson),
              })
            }
          }


          let allCourseIds = [];
          for (var i = 0; i < this.chapters.length; i++) {
            let el = this.chapters[i]
            let topic = {
              type: el.type,
              cut: 0,
              title: el.json ? el.json.title : '',
              detail: el.json ? el.json.detail : '',
              atype: el.json ? el.json.type : '',
              choice: el.json ? el.json.array : '',
              array: [],
              answer: el.json ? el.json.answer : '',
              answer2: '',
              count: 0,
              courses: el.json ? el.json.courses : [],
              small: el.json ? el.json.small : '',
              big: el.json ? el.json.big : '',
            }
            if (topic.type == 1) {
              for (var t = 0; t < topic.choice.length; t++) {
                topic.array.push({
                  name: topic.choice[t].option,
                  count: 0
                })
              }
            } else if (topic.type == 3) {

            } else if (topic.type == 5) {

            } else if (topic.type == 6) {
              let _answer = topic.array

              allCourseIds = allCourseIds.concat(_answer);
            } else if (topic.type == 7) {
              for (var t = parseInt(topic.small); t <= parseInt(topic.big); t++) {
                topic.array.push({
                  name: t,
                  count: 0
                })
              }
            } else if (topic.type == 11) {
              const uniqueArray = courseCount11.filter((item, index) => courseCount11.indexOf(item) === index);
              let _answer = uniqueArray
              
              allCourseIds = allCourseIds.concat(_answer);
            }
            for (var j = 0; j < array.length; j++) {
              let el2 = array[j]
              if (topic.type == 1) {
                let _answer = el2.array[i].json.answer2
                for (var k = 0; k < _answer.length; k++) {
                  topic.array[_answer[k]].count++
                  topic.count++
                }
              } else if (topic.type == 3 || topic.type == 8) {
                let type3 = 1
                let _answer = el2.array[i].json.answer2
                if (_answer) {
                  for (var k = 0; k < topic.array.length; k++) {
                    if (topic.array[k].name == _answer) {
                      topic.array[k].count++
                      type3 = 2
                      topic.count++
                      break;
                    }
                  }
                  if (type3 == 1) {
                    topic.array.push({
                      name: _answer,
                      count: 1
                    })
                  }
                }
              } else if (topic.type == 5) {
                let _answer = el2.array[i].json.file ? el2.array[i].json.file : []
                let _user = {userid:el2.userid,username:el2.name}
                for (var k = 0; k < _answer.length; k++) {
                  topic.array.push({..._answer[k],..._user})
                }
              } else if (topic.type == 7) {
                if(el2.array[i].json.answer2){
                  let _answer = el2.array[i].json.answer2
                  topic.array[_answer].count++
                  topic.count++
                }
              }else if (topic.type == 6) {
                if(el2.array[i].json.courses){
                  let _answer = el2.array[i].json.courses.length ? el2.array[i].json.courses.join(",") : ''
                  topic.answer2 = _answer
                }
              } else if (topic.type == 11) {
                  const uniqueArray = courseCount11.filter((item, index) => courseCount11.indexOf(item) === index);
                  let _answer = uniqueArray
                  topic.answer2 = _answer
              }
            }
            console.log('topictopictopictopic',topic)
            testArray.push(topic)
            this.fileLoading.push({bool:false,count:0,load:0,progress:0})
          }

          // 去重courseId
          allCourseIds = Array.from(new Set(allCourseIds));

          let params = [{
            cid: allCourseIds.join(",")
          }]

          let data = await this.ajax.post(this.$store.state.api + 'getCourseInfoTestAll2',params);
          let result = data.data[0]

          for (var i = 0; i < this.chapters.length; i++) {
            let el = this.chapters[i]
            let topic = testArray[i]
            if (topic.type == 6 || topic.type == 11) {
              result.forEach(i=>{
                i.update_at = new Date(i.update_at).toLocaleString('zh-CN', {year: 'numeric',month: '2-digit',day: '2-digit',hour: '2-digit',minute: '2-digit',second: '2-digit',hour12: false}).replace(/\//g,'-')
              })
              if(topic.type == 6){
                result.forEach(elc=>{
                  if(this.chapters.find(f=>f.type==6).nameFilters.find(c=>c.value==elc.title)==undefined && topic.answer2.includes(elc.courseId)){
                    this.chapters.find(c=>c.type==6).nameFilters.push({text:elc.title,value:elc.title})
                  }
                })
              }else if(topic.type == 11){
                result.forEach(elc=>{
                  if(this.chapters.find((f, index)=>index==i).nameFilters.find(c=>c.value==elc.title)==undefined && topic.answer2.includes(elc.courseId)){
                    this.chapters.find((c, index)=>index==i).nameFilters.push({text:elc.title,value:elc.title})
                  }                
                })
              }

              // this.chapters.find(i=>i.type==6 || i.type==11).nameFilters = result.map(r=>{return{text:r.title,value:r.courseId}})
              if(topic.answer2.length){
                let _answer = topic.answer2
                topic.courseArray = result.filter(el => {
                    return _answer.includes(el.courseId)
                });
              }else{
                topic.courseArray = []
              }
              // topic.courseArray = result
            }
          }
          this.testArray = testArray
          this.worksArray = array
          this.isLoading = false;
          
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getData2() {
      this.isLoading = true;
      let params = {
        cid: this.cid,
        page: this.page,
        pageSize: this.pageSize,
        cn: this.courseName
      };
      this.ajax
        .get(this.$store.state.api + "getTestWorksPage3", params)
        .then((res) => {
          this.isLoading = false;
          this.total = res.data[0].length > 0 ? res.data[0][0].num : 0;
          this.tableData = res.data[0];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setJSON(json) {
      return json.filter((item) => {
        if (item.array) {
          item.array = item.array.filter((item2) => {
            if (item2.ttype == 1 && item2.json) {
              delete item2.json.answer2
              delete item2.json.score2
              delete item2.json.file
            }
            if (item2.array) {
              item2.array = item2.array.filter((item3) => {
                if (item3.ttype == 1 && item3.json) {
                  delete item3.json.answer2
                  delete item3.json.score2
                  delete item3.json.file
                }
                return item3;
              });
            }
            return item2;
          });
        } else if (item.ttype == 1 && item.json) {
          delete item.json.answer2
          delete item.json.score2
          delete item.json.file
        }
        return item
        console.log(item.array);
      });
    },
    setJson2(json) {
      let _json = json;
      // this.type = _json[0].ttype;
      let checkArray = _json.filter((item) => {
        if (item.array) {
          item.array = item.array.filter((item2) => {
            if (item2.ttype == 1 && item2.json && !item2.json.answer2) {
              item2.json.answer2 = [];
            }
            if (item2.array) {
              item2.array = item2.array.filter((item3) => {
                if (item3.ttype == 1 && item3.json && !item3.json.answer2) {
                  item3.json.answer2 = [];
                }
                return item3;
              });
            }
            return (
              (item2.ttype != 1 && item2.array.length > 0) || item2.ttype == 1
            );
          });
        }
        if (item.ttype == 1 && item.json && !item.json.answer2) {
          item.json.answer2 = [];
        }
        console.log(item.array);
        return (item.ttype != 1 && item.array.length > 0) || item.ttype == 1;
      });
      console.log(checkArray);
      return checkArray;

    },
    JSONSetting(json) {
      let _json = json
      let array = []
      _json.filter((item) => {
        if (item.array) {
          item.array = item.array.filter((item2) => {
            if (item2.ttype == 1 && item2.json) {
              array.push(item2)
            }
            if (item2.array) {
              item2.array = item2.array.filter((item3) => {
                if (item3.ttype == 1 && item3.json) {
                  array.push(item3)
                }
                return item3;
              });
            }
            return item2;
          });
        }
        if (item.ttype == 1 && item.json) {
          array.push(item)
        }
        console.log(item.array);
        return item;
      });
      console.log(array);
      return array;
    },
    setFilter(json) {
      let _json = json
      let array = []
      _json.filter((item) => {
        item.nameFilters = [],
          item.filterParams = {
            name: [],
          }
        if (item.type == 1) {
          for (var i = 0; i < item.json.array.length; i++) {
            item.nameFilters.push({ text: item.json.array[i].option, value: item.json.array[i].option })
          }
        }

        array.push(item)
        return item;
      });
      return array
    },
    checkFile(item) {
      if (item.type == 3) {
        this.$hevueImgPreview(item.url);
      } else if (item.type == 5) {
        this.downloadFile(item);
      } else if (item.type == 1) {
        this.dialogVisibleOffice = true
        this.wurl = item.url
      } else if (item.type == 2) {
        this.dialogVisibleVideo = true
        this.wurl = item.url
      } else if (item.type == 4) {
        this.dialogVisiblePdf = true
        this.wurl = item.url
      }
    },
    downloadFile(f) {
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域
      let url2 = f.url;
      let _url2 = "";
      if (
        url2.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
      ) {
        _url2 = url2.split(
          "https://view.officeapps.live.com/op/view.aspx?src="
        )[1];
      } else {
        _url2 = url2;
      }
      let _this = this;

      _this.downLoading = _url2
      var s3 = new window.AWS.S3({ params: { Bucket: "ccrb" } });
      let name = decodeURIComponent(_url2.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1].replace(/\+/g, ' '))
      var params = {
        Bucket: "ccrb",
        Key: name
      };
      s3.getObject(params, function (err, data) {
        _this.downLoading = ''
        if (err) console.log(err, err.stack); // an error occurred
        else {
          let url = window.URL.createObjectURL(new Blob([data.Body]));
          let a = document.createElement("a");
          a.name = f.name;
          a.href = url;
          a.download = f.name;
          a.click();
          console.log(data);
        }          // sxuccessful response

      });
    },
    deleteTest(tid) {
      let _this = this
      _this
        .$confirm("确定删除此提交的表单么？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let params = [{
            tid: tid,
          }];
          _this.ajax
            .post(_this.$store.state.api + "deleteTestCourseWorks", params)
            .then((res) => {
              _this.$message.success("删除成功");
              if (_this.stype == 3) {
                _this.getData2();
              } else {
                _this.getData();
              }
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch(() => {
          return;
        });

    },
    exportPDF() {
      this.pdfLoading = true
      var a = document.getElementsByTagName("img")
      for (var i = 0; i < a.length; i++) { a[i].crossOrigin = "*" }
      downloadPDF(this.$refs.stepBox, this.testJson.title, () => {
        var _a = document.getElementsByTagName("img")
        for (var i = 0; i < _a.length; i++) {
          _a[i].removeAttribute("crossorigin")
        }
        setTimeout(() => {
          this.pdfLoading = false

        }, 2000);
      })
    },
    score(json) {
      let score = 0
      json.forEach(el => {
        if ((el.ttype == 3 || el.ttype == 2) && el.array.length > 0) {
          el.array.forEach(item => {
            if (item.ttype == 2 && item.array.length > 0) {
              item.array.forEach(item2 => {
                if (item2.ttype == 1 && item2.json) {
                  score += item2.json.score ? parseFloat(item2.json.score) : 0
                }
              })
            } else if (item.ttype == 1 && item.json) {
              score += item.json.score ? parseFloat(item.json.score) : 0
            }
          })
        } else if (el.ttype == 1 && el.json) {
          score += el.json.score ? parseFloat(el.json.score) : 0
        }
      })
      return score > 0 ? score + '分' : ''
    },
    score2(json) {
      let score = 0
      // let type = 1
      json.forEach(el => {
        if ((el.ttype == 3 || el.ttype == 2) && el.array.length > 0) {
          el.array.forEach(item => {
            if (item.ttype == 2 && item.array.length > 0) {
              item.array.forEach(item2 => {
                if (item2.ttype == 1 && item2.json) {
                  score += item2.json.score2 ? parseFloat(item2.json.score2) : 0
                }
              })
            } else if (item.ttype == 1 && item.json) {
              score += item.json.score2 ? parseFloat(item.json.score2) : 0
            }
          })
        } else if (el.ttype == 1 && el.json) {
          score += el.json.score2 ? parseFloat(el.json.score2) : 0
        }
      })
      return score + '分'
    },
    setWordHtml(data) {
      let _data = data

      let _title = `<div style="font-size:30px;font-weight:bold;text-align:center;">${this.testJson.title}</div>`;
      let score = this.score(data.courseJson)
      let isScore = this.score2(data.courseJson)
      let scoreContent = score ? `<b>（得分/总分）${isScore}/${score}</b>` : ''
      let _content = `<div style="text-align:center;margin-top: 20px;"><b style="margin-right:40px">（答题人）${_data.name}</b>${scoreContent}（填写范围）${this.testJson.juriP ? this.testJson.juriP : '所有人'}（提交时间）${_data.time}</div>`
      let _detail = this.testJson.brief ? `<div style="text-align:center;margin-top: 20px;">${this.testJson.brief}</div>` : ''

      let _test = `<div style='margin-top:40px;'>`
      for (let i = 0; i < _data.array.length; i++) {
        let item = _data.array[i]
        let _div = `<div style='margin-top:20px;font-weight:bold;'>${i + 1}、${item.json.title}</div>`
        _test += _div
        if (item.type == 1) {
          for (let j = 0; j < item.json.array.length; j++) {
            let check = item.json.array[j]
            let _option = `<div style='margin:10px 0 0 40px;'>${(item.json.answer2 && item.json.answer2.indexOf(j) !== -1) ? '☑' : '☐'} ${check.option}</div>`
            _test += _option
          }
        } else if (item.type == 3 && item.json.answer2) {
          let _option = `<div style='margin:10px 0 0 40px;'>${item.json.answer2}</div>`
          _test += _option
        } else if (item.type == 5 && item.json.file) {
          for (let j = 0; j < item.json.file.length; j++) {
            let check = item.json.file[j]
            let _option = `<div style='margin:10px 0 0 40px;'>${check.name} <a href='${check.url}'>${check.url}</a></div>`
            _test += _option
          }
        } else if (item.type == 6 && item.json.answer2) {
            let _option = `<div style='margin:10px 0 0 40px;'>打分课程：${item.json.answer2}</div>`
            _test += _option
        } else if (item.type == 7 && item.json.answer2 ) {
            let _score = this.getScore2(item.json)
            let _option = `<div style='margin:10px 0 0 40px;'>打分：${_score}分</div>`
            _test += _option
        } else if (item.type == 8 && item.json.answer2) {
          let _option = `<div style='margin:10px 0 0 40px;'>${item.json.answer2}</div>`
          _test += _option
        } else if (item.type == 11 && item.json.answer2) {
            let _option = `<div style='margin:10px 0 0 40px;'>打分课程：${item.json.answer2}</div>`
            _test += _option
        }
      }
      _test += `</div>`
      let _html = _title + _content + _detail + _test;
      this.exportToWord(_data.name + '-' + _data.time, _html);
    },
    setWordHtml2(data) {
      let _data = data
      _data.array = this.JSONSetting(JSON.parse(JSON.stringify(JSON.parse(data.courseJson))))
      let _title = `<div style="font-size:30px;font-weight:bold;text-align:center;">${this.testJson.title}</div>`;
      let score = this.score(JSON.parse(data.courseJson))
      let isScore = this.score2(JSON.parse(data.courseJson))
      let scoreContent = score ? `<b>（得分/总分）${isScore}/${score}</b>` : ''
      let _content = `<div style="text-align:center;margin-top: 20px;"><b style="margin-right:40px">（答题人）${_data.username ? _data.username : '匿名'}</b>${scoreContent}（填写范围）${this.testJson.juriP ? this.testJson.juriP : '所有人'}（提交时间）${_data.time}</div>`
      let _detail = this.testJson.brief ? `<div style="text-align:center;margin-top: 20px;">${this.testJson.brief}</div>` : ''

      let _test = `<div style='margin-top:40px;'>`
      for (let i = 0; i < _data.array.length; i++) {
        let item = _data.array[i]
        let _div = `<div style='margin-top:20px;font-weight:bold;'>${i + 1}、${item.json.title}</div>`
        _test += _div
        if (item.type == 1) {
          for (let j = 0; j < item.json.array.length; j++) {
            let check = item.json.array[j]
            let _option = `<div style='margin:10px 0 0 40px;'>${(item.json.answer2 && item.json.answer2.indexOf(j) !== -1) ? '☑' : '☐'} ${check.option}</div>`
            _test += _option
          }
        } else if (item.type == 3 && item.json.answer2) {
          let _option = `<div style='margin:10px 0 0 40px;'>${item.json.answer2}</div>`
          _test += _option
        } else if (item.type == 5 && item.json.file) {
          for (let j = 0; j < item.json.file.length; j++) {
            let check = item.json.file[j]
            let _option = `<div style='margin:10px 0 0 40px;'>${check.name} <a href='${check.url}'>${check.url}</a></div>`
            _test += _option
          }
        } else if (item.type == 6 && item.json.answer2) {
            let _option = `<div style='margin:10px 0 0 40px;'>打分课程：${item.json.answer2}</div>`
            _test += _option
        } else if (item.type == 7 && item.json.answer2 ) {
            let _score = this.getScore2(item.json)
            let _option = `<div style='margin:10px 0 0 40px;'>打分：${_score}分</div>`
            _test += _option
        } else if (item.type == 8 && item.json.answer2) {
          let _option = `<div style='margin:10px 0 0 40px;'>${item.json.answer2}</div>`
          _test += _option
        } else if (item.type == 11 && item.json.answer2) {
            let _option = `<div style='margin:10px 0 0 40px;'>打分课程：${item.json.answer2}</div>`
            _test += _option
        }
      }
      _test += `</div>`
      let _html = _title + _content + _detail + _test;
      this.exportToWord(_data.username ? _data.username : '匿名' + '-' + _data.time, _html);
    },
    async exportToWord(a, html) {
      // 将html文件中需要用到的数据挂载到store上
      const content = `<!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${a}</title>
          <style>
          </style>
      </head>
      <body>
      ${html}
      </body>
      </html>`;
      // debugger
      // 生成报告
      const link = document.createElement("a");
      let dname = a + ".doc";
      // link.download = "报告.html"; // 文件名
      link.download = dname; // 文件名
      link.style.display = "none";
      // 创建文件流
      // 创建bolb实例时，内容一定要放在[]中
      const blob = new Blob([content], {
        type: "text/plain;charset='utf-8'",
      });
      link.href = window.URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    setWordHtmlAll(data) {
      let _data = data

      let _title = `<div style="font-size:30px;font-weight:bold;text-align:center;">${this.testJson.title}</div>`;
      let score = this.score(data.courseJson)
      let isScore = this.score2(data.courseJson)
      let scoreContent = score ? `<b>（得分/总分）${isScore}/${score}</b>` : ''
      let _content = `<div style="text-align:center;margin-top: 20px;"><b style="margin-right:40px">（答题人）${_data.name}</b>${scoreContent}（填写范围）${this.testJson.juriP ? this.testJson.juriP : '所有人'}（提交时间）${_data.time}</div>`
      let _detail = this.testJson.brief ? `<div style="text-align:center;margin-top: 20px;">${this.testJson.brief}</div>` : ''

      let _test = `<div style='margin-top:40px;'>`
      for (let i = 0; i < _data.array.length; i++) {
        let item = _data.array[i]
        let _div = `<div style='margin-top:20px;font-weight:bold;'>${i + 1}、${item.json.title}</div>`
        _test += _div
        if (item.type == 1) {
          for (let j = 0; j < item.json.array.length; j++) {
            let check = item.json.array[j]
            let _option = `<div style='margin:10px 0 0 40px;'>${(item.json.answer2 && item.json.answer2.indexOf(j) !== -1) ? '☑' : '☐'} ${check.option}</div>`
            _test += _option
          }
        } else if (item.type == 3 && item.json.answer2) {
          let _option = `<div style='margin:10px 0 0 40px;'>${item.json.answer2}</div>`
          _test += _option
        } else if (item.type == 5 && item.json.file) {
          for (let j = 0; j < item.json.file.length; j++) {
            let check = item.json.file[j]
            let _option = `<div style='margin:10px 0 0 40px;'>${check.name} <a href='${check.url}'>${check.url}</a></div>`
            _test += _option
          }
        } else if (item.type == 6 && item.json.answer2) {
            let _option = `<div style='margin:10px 0 0 40px;'>打分课程：${item.json.answer2}</div>`
            _test += _option
        } else if (item.type == 7 && item.json.answer2 ) {
            let _score = this.getScore2(item.json)
            let _option = `<div style='margin:10px 0 0 40px;'>打分：${_score}分</div>`
            _test += _option
        } else if (item.type == 8 && item.json.answer2) {
          let _option = `<div style='margin:10px 0 0 40px;'>${item.json.answer2}</div>`
          _test += _option
        } else if (item.type == 11 && item.json.answer2) {
            let _option = `<div style='margin:10px 0 0 40px;'>打分课程：${item.json.answer2}</div>`
            _test += _option
        } 
      }
      _test += `</div>`
      let _html = _title + _content + _detail + _test;
      return this.exportToWordAll(_data.name + '-' + _data.time, _html);
    },
    async setWordHtmlAll2(data) {
      let _data = data
      _data.array = this.JSONSetting(JSON.parse(JSON.stringify(JSON.parse(data.courseJson))))
      let _title = `<div style="font-size:30px;font-weight:bold;text-align:center;">${this.testJson.title}</div>`;
      let score = this.score(JSON.parse(data.courseJson))
      let isScore = this.score2(JSON.parse(data.courseJson))
      let scoreContent = score ? `<b>（得分/总分）${isScore}/${score}</b>` : ''
      let _content = `<div style="text-align:center;margin-top: 20px;"><b style="margin-right:40px">（答题人）${_data.username ? _data.username : '匿名'}</b>${scoreContent}（填写范围）${this.testJson.juriP ? this.testJson.juriP : '所有人'}（提交时间）${_data.time}</div>`
      let _detail = this.testJson.brief ? `<div style="text-align:center;margin-top: 20px;">${this.testJson.brief}</div>` : ''

      let _test = `<div style='margin-top:40px;'>`
      for (let i = 0; i < _data.array.length; i++) {
        let item = _data.array[i]
        let _div = `<div style='margin-top:20px;font-weight:bold;'>${i + 1}、${item.json.title}</div>`
        _test += _div
        if (item.type == 1) {
          for (let j = 0; j < item.json.array.length; j++) {
            let check = item.json.array[j]
            let _option = `<div style='margin:10px 0 0 40px;'>${(item.json.answer2 && item.json.answer2.indexOf(j) !== -1) ? '☑' : '☐'} ${check.option}</div>`
            _test += _option
          }
        } else if (item.type == 3 && item.json.answer2) {
          let _option = `<div style='margin:10px 0 0 40px;'>${item.json.answer2}</div>`
          _test += _option
        } else if (item.type == 5 && item.json.file) {
          for (let j = 0; j < item.json.file.length; j++) {
            let check = item.json.file[j]
            let _option = `<div style='margin:10px 0 0 40px;'>${check.name} <a href='${check.url}'>${check.url}</a></div>`
            _test += _option
          }
        } else if (item.type == 6 && item.json.answer2) {
            let _cjson = await this.getCourse(item.json.answer2)
            let _option = `<div style='margin:10px 0 0 40px;'>打分课程：${ _cjson ? _cjson.title : ''}</div>`
            _test += _option
        } else if (item.type == 7 && item.json.answer2 ) {
            let _score = this.getScore2(item.json)
            let _option = `<div style='margin:10px 0 0 40px;'>打分：${_score}分</div>`
            _test += _option
        } else if (item.type == 8 && item.json.answer2) {
          let _option = `<div style='margin:10px 0 0 40px;'>${item.json.answer2}</div>`
          _test += _option
        } else if (item.type == 11 && item.json.answer2 && item.json.answer2.length) {
            let _answer = item.json.answer2
            _answer.length ? courseCount11 = courseCount11.concat(_answer) : ''
            _json[ja].json.courseId = _answer ? _answer : [];
            let params = [{
              cid:_answer.length ? _answer.join(",") : ''
            }]

            let data = await this.ajax.post(this.$store.state.api + 'getCourseInfoTestAll2',params);
            let result = data.data[0]
            let _title = []
            // this.chapters.find(i=>i.type==6).nameFilters = result.map(r=>{return{text:r.title,value:r.courseId}})
            result.forEach(i=>{
              _title.push(i.title)
            })
            
            let _option = `<div style='margin:10px 0 0 40px;'>打分课程：${ _title.length ? _title.join(',') : '' }</div>`
            _test += _option
        }
      }
      _test += `</div>`
      let _html = _title + _content + _detail + _test;
      return this.exportToWordAll(_data.username ? _data.username : '匿名' + '-' + _data.time, _html);
    },
    async exportToWordAll(a, html) {
      // 将html文件中需要用到的数据挂载到store上
      const content = `<!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${a}</title>
          <style>
          </style>
      </head>
      <body>
      ${html}
      </body>
      </html>`;
      // debugger
      // 生成报告
      const link = document.createElement("a");
      let dname = a + ".doc";
      // link.download = "报告.html"; // 文件名
      link.download = dname; // 文件名
      link.style.display = "none";
      // 创建文件流
      // 创建bolb实例时，内容一定要放在[]中
      const blob = new Blob([content], {
        type: "text/plain;charset='utf-8'",
      });
      return blob;
    },
    exportAllWord() {
      this.pdfLoading = true;
      const _chapInfo = this.worksArray;
      let url = [];
      for (let i = 0; i < _chapInfo.length; i++) {
        url.push({
          name: _chapInfo[i].name + '-' + _chapInfo[i].time,
          blob: this.setWordHtmlAll(_chapInfo[i]),
        });
      }
      console.log(url);
      this.downLoadAll(url);
    },
    exportAllWord2() {
      this.pdfLoading = true;

      let params = {
        cid: this.cid,
        page: 1,
        pageSize: 999,
        cn: this.courseName
      };
      this.ajax
        .get(this.$store.state.api + "getTestWorksPage3", params)
        .then((res) => {
          const _chapInfo = res.data[0];
          let url = [];
          for (let i = 0; i < _chapInfo.length; i++) {
            url.push({
              name: _chapInfo[i].username + '-' + _chapInfo[i].time,
              blob: this.setWordHtmlAll2(_chapInfo[i]),
            });
          }
          console.log(url);
          this.downLoadAll(url);
        })
        .catch((err) => {
          console.error(err);
        });

    },
    downLoadAll(url) {
      const data = url; // 需要下载打包的路径, 可以是本地相对路径, 也可以是跨域的全路径
      const zip = new JSZip();
      const cache = {};
      data.forEach((item) => {
        // 下载文件, 并存成ArrayBuffer对象
        const file_name = item.name; // 获取文件名
        zip.file(file_name + '.doc', item.blob, { binary: true }); // 逐个添加文件
        cache[file_name] = item.blob;
      });
      zip.generateAsync({ type: "blob" }).then((content) => {
        // 生成二进制流
        FileSaver.saveAs(content, this.testJson.title + ".zip"); // 利用file-saver保存文件  自定义文件名
        setTimeout(() => {
          this.pdfLoading = false;
        }, 2000);
      });
    },
    handleFilterChange() {
      console.log(this.$refs.table.store.states.data);
    },
    exportExcel() {
      let res = this.$refs.table.store.states.data
      if (!res.length) {
        this.$message.error('无导出数据')
        return
      }
      this.isLoading = true;
      let chapters = this.chapters

      var array = [];
      for (var i = 0; i < res.length; i++) {
        var _json = {};
        _json["序号"] = i + 1;
        _json["提交人"] = res[i].name ? res[i].name : '匿名';
        _json["提交时间"] = res[i].time;
        for (var j = 0; j < chapters.length; j++) {
          _json[j + 1 + "." + chapters[j].json.title] = '';
          if (res[i].array[j].type == 1 && res[i].array[j].json.answer2) {
            let a = []
            for (var answer2 = 0; answer2 < res[i].array[j].json.answer2.length; answer2++) {
              a.push(res[i].array[j].json.array[res[i].array[j].json.answer2[answer2]].option)
            }
            _json[j + 1 + "." + chapters[j].json.title] = a.join('、')
          } else if (res[i].array[j].type == 3 && res[i].array[j].json.answer2) {
            _json[j + 1 + "." + chapters[j].json.title] = res[i].array[j].json.answer2
          } else if (res[i].array[j].type == 5 && res[i].array[j].json.file) {
            let files = []
            for (let file = 0; file < res[i].array[j].json.file.length; file++) {
              let check = res[i].array[j].json.file[file]
              files.push(file + 1 + '.' + check.name + '----' + check.url)
            }
            _json[j + 1 + "." + chapters[j].json.title] = files.join('\n')
          } else if (res[i].array[j].type == 6 && res[i].array[j].json.answer2) {
            _json[j + 1 + "." + chapters[j].json.title] = res[i].array[j].json.answer2
          } else if (res[i].array[j].type == 7 && res[i].array[j].json.answer2) {
            let _score = this.getScore2(res[i].array[j].json)
            _json[j + 1 + "." + chapters[j].json.title] = _score
          } else if (res[i].array[j].type == 8 && res[i].array[j].json.answer2) {
            _json[j + 1 + "." + chapters[j].json.title] = res[i].array[j].json.answer2
          } else if (res[i].array[j].type == 11 && res[i].array[j].json.answer2) {
            _json[j + 1 + "." + chapters[j].json.title] = res[i].array[j].json.answer2
          }
        }
        array.push(_json);
      }
      let widthJson = []
      let widthArray = Object.keys(array[0])
      for (let i = 0; i < widthArray.length; i++) {
        if (i == 0) {
          widthJson.push({ wch: 5 })
        } else {
          widthJson.push({ wch: 30 })
        }
      }

      const workbook = XLSX.utils.book_new(); //创建一个新的工作簿对象
      let ws = XLSX.utils.json_to_sheet(array); //将json对象数组转化成工作表
      ws["!cols"] = widthJson;
      const styleObj = {
        alignment: {
          horizontal: "center",
          vertical: "center" // 设置垂直居中
        }
      }; // 设置居中对齐和加粗样式

      for (let cell in ws) {
        if (!cell[0].startsWith("!")) {
          ws[cell]["s"] = styleObj;
        }
      }

      XLSX.utils.book_append_sheet(workbook, ws, "sheet1"); //把sheet添加到workbook里，第三个参数是sheet名

      XLSX.writeFile(workbook, this.testJson.title + ".xlsx");
      this.isLoading = false;
      this.$message({
        message: "导出成功",
        type: "success"
      });
    },
    async getCourse(id) {
      let params = {
        cid: id,
      };
      let res = await this.ajax.get(this.$store.state.api + "getCourseInfoTest", params)
      return res.data[0][0]
    },
    getScore2(item) {
        let array = []
        for (var i = parseInt(item.small); i <= parseInt(item.big); i++) {
          array.push(i)
        }
        return item.answer2 ? array[item.answer2] : ''
    },
    checkScreenSize() {
      this.screenWidth = window.innerWidth;
      this.isDesktop = this.screenWidth > 750; // 你可以根据需要调整这个阈值
    },
		downloadFileType5(fileData,title="附件",index){
      this.fileLoading[index].bool = true
      this.fileLoading[index].count = 0
      this.fileLoading[index].load = 0
      this.fileLoading[index].progress = 0


			let data = fileData;
			const zip = new JSZip();
			let downFileArray = [];
			let uniqueArr = data.filter((v,i,a)=>a.map(mb=>mb.userid).indexOf(v.userid)==i);
			uniqueArr.forEach(i=>{
				downFileArray.push({userid:i.userid,username:i.username ? i.username : '匿名',urlList:data.filter(d=>d.userid==i.userid).map(m=>m)});
			})
			let promises = [];
      console.log('downFileArray',downFileArray);
      downFileArray.forEach(e=>{
        this.fileLoading[index].count += e.urlList.length
      })

			if(downFileArray.length==1){//只有一位老师的情况
				if(downFileArray[0].urlList.length>1){//多个文件的情况
					const folder = zip.folder(`${downFileArray[0].username}`);
					downFileArray[0].urlList.forEach(i=>{
						const promise = getFile(i.url).then((data) => {
        	      if (data.data != 1) {
        	          // 下载文件, 并存成ArrayBuffer对象
        	          const file_name = i.name; // 获取文件名
									  folder.file(file_name, data.data, { binary: true }); // 逐个添加文件
        	      }
                this.fileLoading[index].load+=1
                this.fileLoading[index].progress = parseInt((this.fileLoading[index].load / this.fileLoading[index].count) * 100);
                if (this.fileLoading[index].load == this.fileLoading[index].count) {
                  this.fileLoading[index].bool=false
                }
        	  });
           
						promises.push(promise)
					})
					
				}else{//只有一个文件的情况
					promises.push(getFile(downFileArray[0].urlList[0].url).then((data) => {
						if (data.data != 1) {
        	      // 下载文件, 并存成ArrayBuffer对象
        	      const file_name = `${downFileArray[0].username}-${downFileArray[0].urlList[0].name}`; // 获取文件名
								zip.file(file_name, data.data, { binary: true }); // 逐个添加文件
            }
            this.fileLoading[index].load+=1
            this.fileLoading[index].progress = parseInt((this.fileLoading[index].load / this.fileLoading[index].count) * 100);
            if (this.fileLoading[index].load == this.fileLoading[index].count) {
              this.fileLoading[index].bool=false
            }
					}))
				}
			}else if(downFileArray.length>1){//有多位老师的情况
				downFileArray.forEach(i=>{
					if(i.urlList.length==1){//只有一个文件的情况
						promises.push(getFile(i.urlList[0].url).then((data) => {
						  if (data.data != 1) {
        	      // 下载文件, 并存成ArrayBuffer对象
        	      const file_name = `${i.username ? i.username : '匿名'}-${i.urlList[0].name}`; // 获取文件名
								zip.file(file_name, data.data, { binary: true }); // 逐个添加文件
              }
              this.fileLoading[index].load+=1
              this.fileLoading[index].progress = parseInt((this.fileLoading[index].load / this.fileLoading[index].count) * 100);
              if (this.fileLoading[index].load == this.fileLoading[index].count) {
                this.fileLoading[index].bool=false
              }
						}))
					}else if(i.urlList.length>1){//有多个文件的
						const folder = zip.folder(`${i.username ? i.username : '匿名'}`);
						i.urlList.forEach(ui=>{
						  const promise = getFile(ui.url).then((data) => {
								if (data.data != 1) {
        	          // 下载文件, 并存成ArrayBuffer对象
        	          const file_name = ui.name; // 获取文件名
									  folder.file(file_name, data.data, { binary: true }); // 逐个添加文件
        	      }
                this.fileLoading[index].load+=1
                this.fileLoading[index].progress = parseInt((this.fileLoading[index].load / this.fileLoading[index].count) * 100);
                if (this.fileLoading[index].load == this.fileLoading[index].count) {
                  this.fileLoading[index].bool=false
                }
						  })
							promises.push(promise)
						})
					}
				})
			}
			Promise.all(promises).then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
              // 生成二进制流
              FileSaver.saveAs(content, `${this.testJson.title}-${title}.zip`); // 利用file-saver保存文件  自定义文件名
          });
      });
		},
    getUserInfo() {
      let params = {
        uid: this.peopleId,
      };
      this.ajax
        .get(this.$store.state.api + "selectTestUser", params)
        .then((res) => {
          console.log('111111111111111111111',res.data[0][0]);
          // 用于存储归类后的数据的对象
          // this.checkDataType(2)
          this.stype = 2
          this.courseName = res.data[0][0].name
          this.searchCourse()
        })
        .catch((err) => {
          console.error(err);
        });
    },
		setWordTemplate(item){
			this.$refs.docxTemplateDialogRef.open({fileData:this.testJson.cover?JSON.parse(this.testJson.cover):null,testJson:this.testJson,courseId:this.testJson.courseId,formData:[item]})//这里可以传数据
		},
		changeCover(data){
			this.testJson.cover = data
		},
		exportWordData(){
			this.$refs.docxTemplateDialogRef.open({fileData:this.testJson.cover?JSON.parse(this.testJson.cover):null,testJson:this.testJson,courseId:this.testJson.courseId,formData:this.worksArray})//这里可以传数据
		}
  },
  beforeDestroy() {
    document.getElementsByTagName('html')[0].style.overflow = '';
    window.removeEventListener("resize", this.checkScreenSize);
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    document.getElementsByTagName('html')[0].scrollTop = 0
    document.getElementsByTagName('html')[0].style.overflow = 'hidden'
    this.$nextTick(function () {
      if(this.peopleId){
        this.getUserInfo();
      }else{
        this.getData();
      }
      // this.getClass2()
      this.changeHeight()
    });
  },
};
</script>

<style scoped>
.pb_content {
  height: 100% !important;
  /* margin: 0 20px 0 20px; */
}
.cutBtnBlockCss{
  width: 100%;display: flex;justify-content: end;
}
.cutBtnCss{
  width: 68px;
  height: 27px;
  font-size: 14px;
  border-radius: 5px;
  display: flex;
  color: rgba(54, 129, 252, 1);
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  border: 1px rgba(54, 129, 252, 1) solid;
}
.isDesktopRight{
  width:100% !important;
  margin:0 !important;
  height: 300px !important;
  border: none !important;
}
.isDTitle2JsonTit{
  width: 130px;
  color: rgba(0, 0, 0, 0.9);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.IsDAnswer{
  margin: 20px 0 30px;color: rgba(0, 0, 0, 0.6);
}

.CutCss{
  height: 60px;
  line-height: 60px;
}
.topicTitCss{
  color:  rgba(0, 0, 0, 0.9);
  font-weight: 600;
  margin-right: 5px;
}
.IsDFile{
  width: 150px;
  height: 120px;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-bottom: 5px;
}
.IsDownload{
  position: absolute;
  width: 30px;
  top: 5px;
  right: 5px;
}
.IsDImg{
  width: 100%;
  height: 70px;
  flex: 1;
}
.pb_content_body {
  width: 100% !important;
  height: 100%;
}

.pb_content_body>.right {
  height: 100%;
  width: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
}

.basic_box {
  margin: 0 auto;
  position: relative;
  padding: 0 20px 0 20px;
}

.courseTop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 40px);
  margin: 0 auto;
  padding: 10px 0;
}

.stepsNav {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.step_box {
  width: calc(100% - 40px);
  margin: 0 auto;
  height: calc(100% - 50px);
  overflow: auto;
  background: #ffff;
  border-radius: 5px;
}

.el-table>>>.even_row {
  background-color: #f1f1f1 !important;
}

.student_page {
  margin-top: 10px;
}

.test_title {
  display: flex;
  padding: 15px 15px;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.test_title .left {
  max-width: 100%;
  margin-top: 10px
}

.test_title .left .title {
  width: 100%;
  font-size: 24px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test_title .left .info {
  display: flex;
  margin-top: 15px;
}

.test_title .left .info .info_box {
  font-size: 14px;
}

.test_title .left .info .info_box+.info_box {
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #E7E7E7;
}

.test_title .left .info .info_box span:nth-child(1) {
  color: #00000099;
}

.test_title .left .info .info_box span:nth-child(2) {}

.test_title .right {
  display: flex;
  align-items: center;
  margin-top: 10px;
  max-width: 100%;
}

.test_title .right .data_box {
  margin-right: 15px;
  width: 150px;
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  padding: 0 10px;
  height: 57px;
  font-size: 14px;
  color: #00000099;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.test_title .right .data_box span:nth-child(1) {}

.test_title .right .data_box span:nth-child(2) {}

.test_title .right .data_box span:nth-child(2) .big {
  font-size: 22px;
}

.test_title .right .btn_box {
  display: flex;
  flex-direction: column;
  width: 57px;
  height: 57px;
  background: #3681fc;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.test_title .right .btn_box span:nth-child(1) {
  display: block;
  width: 12px;
  height: 14px;
  margin-bottom: 5px;
  background-image: url('../../../../assets/icon/test/icon_share.png');
  background-size: 100% 100%;
}

.test_title .right .btn_box span:nth-child(2) {}

.search_nav {
  border-bottom: 1px solid #E7E7E7;
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px 10px;
  display: flex;
  align-items: flex-end;
  height: 50px;
}

.search_nav>.right {
  display: flex;
  align-items: center;
}

.search_nav>.right>span {
  height: 24px;
  font-size: 14px;
  color: #000;
  cursor: pointer;
  position: relative;
}
.search_nav>.isDesktopRightCut{
  display: flex;
  justify-content: space-between;
  width: 60%;
}
.search_nav>.right>span+span {
  margin-left: 35px;
}

.search_nav>.right>span.active {
  color: #3681FC;
  font-weight: 600;
}

.search_nav>.right>span.active::before {
  content: "";
  position: absolute;
  bottom: -10px;
  width: 15px;
  height: 3px;
  background: #3681fc;
  left: 50%;
  transform: translateX(-50%);
}

.search_nav>.left {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.search_nav>.right>span.active2 {
  color: #3681FC;
  font-weight: 600;
}
.search_nav>.right>span.active2::before {
  content: "";
  position: absolute;
  bottom: -10px;
  width: 100%;
  height: 3px;
  background: #3681fc;
  left: 50%;
  transform: translateX(-50%);
}


.student_input>>>.el-input__inner {
  height: 40px;
  width: 190px;
  font-size: 13px;
  padding: 0 35px 0 10px;
}

.serach_icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 13px;
  height: 13px;
  background: url("../../../../assets/icon/test/test_search.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}


.title_content {
  padding-bottom: 10px;
}

.title_content>.title_box {
  width: calc(100% - 48px);
  margin: 20px auto 0;
}

.title_content>.title_box>.title {
  font-size: 18px;
  display: flex;
  min-height: 35px;
  white-space: pre-line;
	position: relative;
}

.title_content>.title_box>.title>.test_icon {
  min-width: 20px;
  height: 20px;
}

.title_content>.title_box>.detail {
  font-size: 14px;
  color: #00000099;
  margin-top: 8px;
  white-space: pre-line;
}

.title_content>.title_box>.content1 {
  display: flex;
  width: 100%;
  margin-top: 10px;
}

.title_content>.title_box>.content1>>>.el-progress__text {
  color: #3681FC;
  min-width: 55px;
  font-size: 16px !important;
}

.title_content>.title_box>.content1>.left {
  width: calc(100% - 620px);
  border: 1px solid #e7e7e7;
}

.title_content>.title_box>.content1>.left>div+div {
  border-top: 1px solid #e7e7e7;
}

.title_content>.title_box>.content1>.left>.title,
.title_content>.title_box>.content1>.left>.data {
  display: flex;
  height: 40px;
  align-items: center;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
  line-height: 16px;
}

.title_content>.title_box>.content1>.left>.title>span,
.title_content>.title_box>.content1>.left>.data>span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title_content>.title_box>.content1>.left>.title>span:nth-child(1),
.title_content>.title_box>.content1>.left>.data>span:nth-child(1) {
  width: calc(100% - 320px - 110px);
}

.title_content>.title_box>.content1>.left>.title>span:nth-child(2),
.title_content>.title_box>.content1>.left>.data>span:nth-child(2) {
  width: 110px;
}

.title_content>.title_box>.content1>.left>.title>span:nth-child(3),
.title_content>.title_box>.content1>.left>.data>span:nth-child(3) {
  width: 320px;
}
.isDesktopTitle{
  display: flex;
  justify-content: space-around;
}
.isDesktopTitle >div {
  width: 60px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* .isDesktopTitle:nth-child(1){
  width: 60px;
}
.isDesktopTitle:nth-child(2){
  width: 60px;
}
.isDesktopTitle:nth-child(3){
  flex: 1;
} */

.title_content>.title_box>.content1>.left>.title {
  font-weight: 700;
  background: #F9FAFB;
}

.title_content>.title_box>.content1>.right {
  width: 600px;
  margin-left: 20px;
  border: 1px solid #e7e7e7;
  min-height: 300px;
}


.title_content>.title_box>.content2 {
  display: flex;
  width: 100%;
  margin-top: 10px;
}

.title_content>.title_box>.content2>.left {
  width: calc(100% - 620px);
  border: 1px solid #e7e7e7;
}

.title_content>.title_box>.content2>.left>div+div {
  border-top: 1px solid #e7e7e7;
}

.title_content>.title_box>.content2>.left>.title,
.title_content>.title_box>.content2>.left>.data {
  display: flex;
  height: 40px;
  align-items: center;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
  line-height: 16px;
}

.title_content>.title_box>.content2>.left>.title>span,
.title_content>.title_box>.content2>.left>.data>span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title_content>.title_box>.content2>.left>.title>span:nth-child(1),
.title_content>.title_box>.content2>.left>.data>span:nth-child(1) {
  width: 55px;
}

.title_content>.title_box>.content2>.left>.title>span:nth-child(2),
.title_content>.title_box>.content2>.left>.data>span:nth-child(2) {
  width: 110px;
}

.title_content>.title_box>.content2>.left>.title>span:nth-child(3),
.title_content>.title_box>.content2>.left>.data>span:nth-child(3) {
  max-width: calc(100% - 110px - 55px);
}

.title_content>.title_box>.content2>.left>.title {
  font-weight: 700;
  background: #F9FAFB;
}

.title_content>.title_box>.content2>.right {
  width: 600px;
  margin-left: 20px;
  border: 1px solid #e7e7e7;
}

.title_content>.title_box>.content2>.right>>>.wordCloud {
  height: auto;
  min-height: 300px;
}

.title_content>.title_box>.content3 {
  display: flex;
  width: 100%;
  overflow: auto;
}

.title_content>.title_box>.content3>.file {
  min-width: 200px;
  width: 200px;
  height: 140px;
  margin: 10px 10px 10px 0px;
  border-radius: 15px;
  box-shadow: rgb(223, 218, 218) 0px 0px 6px 1px;
  overflow: hidden;
  margin-right: 15px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.title_content>.title_box>.content3>.file>.img {
  width: 100%;
  height: calc(100% - 35px);
  object-fit: cover;
  cursor: pointer;
}

.title_content>.title_box>.content3>.file>.del {
  position: absolute;
  width: 25px;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.title_content>.title_box>.content3>.file>.download {
  position: absolute;
  width: 25px;
  top: 10px;
  right: 35px;
  cursor: pointer;
  opacity: .8;
}


.title_content>.title_box>.content3>.file>.name {
  height: 35px;
  width: 100%;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}

.title_content>.title_box>.content3>.file>.name>span {
  display: block;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
}

.table_content {
  /* width: calc(100% - 48px);
  margin: 20px auto 0; */
  padding: 20px 24px;
  width: 100%;
  box-sizing: border-box;
}

.table_content>>>.el-table td {
  padding: 5px 0;
}
.isDesktopTable_content{
  width: 100%;
}
.isDTitle{
  display: flex;
  justify-content: space-between;
}
.isDBri{
  display: flex;
  padding: 15px 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
  flex-direction: column;
  height: 80px;
  justify-content: space-between;
}

.answer_type {
  background: #F0F2F5;
  padding: 5px 10px;
  display: block;
  border-radius: 3px;
  margin: 5px;
}



.table_file>.file {
  min-width: 100px;
  width: 100px;
  height: 70px;
  margin: 10px 10px 10px 0px;
  border-radius: 5px;
  box-shadow: rgb(223, 218, 218) 0px 0px 6px 1px;
  overflow: hidden;
  margin-right: 15px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.table_file>.file>.img {
  width: 100%;
  height: calc(100% - 20px);
  object-fit: cover;
  cursor: pointer;
}

.table_file>.file>.del {
  position: absolute;
  width: 25px;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.table_file>.file>.download {
  position: absolute;
  width: 25px;
  top: 10px;
  right: 35px;
  cursor: pointer;
  opacity: .8;
}


.table_file>.file>.name {
  height: 20px;
  width: 100%;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  font-size: 12px;
}

.table_file>.file>.name>span {
  display: block;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
}

.btnA {
  color: #fff;
  background-color: #0061FF;
  padding: 0 24px;
  font-size: 14px;
  min-width: 64px;
  font-weight: 500;
  border-radius: 4px;
  box-sizing: border-box;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  margin-right: 10px;
  position: relative;
}

.buttonBox {
  position: absolute;
  bottom: -0;
  transform: translateY(100%);
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 3px 1px #e3e3e3;
  width: 100%;
  z-index: 999;
}

.buttonBox>div {
  height: 40px;
  line-height: 40px;
  width: 100%;
  text-align: center;
  color: #000;
  box-sizing: border-box;
}

.buttonBox>div+div {
  border-top: 1px solid #e0e0e0;
}

.buttonBox>div:hover {
  background: #f6f8ff;
}

.content4 {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
}

.out_box {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  /* width: 200px; */
  min-width: 280px;
  width: 280px;
  background: #fff;
  /* background-color: white; */
  margin-right: 15px;
  /* border: 1px solid #ccc; */
  height: fit-content;
  box-sizing: border-box;
  border-radius: 0px 0px 5px 5px;
  /* overflow: hidden; */
  margin-bottom: 15px;
  position: relative;
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #3682fc00;
  cursor: pointer;
  border: 1px solid #6a9ff5;
  height: auto;
}

.out_boxActive {
  box-sizing: border-box;
  border: 3px solid #3681FC !important;

}

.out_box:hover {
  border: 1px solid #3681FC;
}


.bottom_box {
  width: 100%;
  display: flex;
  padding: 10px;
  flex-direction: column;
  box-sizing: border-box;
  height: 121px;
  flex-wrap: nowrap;
  justify-content: space-evenly;
}

.bottom_box>div:nth-child(1) {
  width: 100%;
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bottom_box>div:nth-child(1)>span:nth-child(1) {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}

.bottom_box>div:nth-child(1)>span:nth-child(2) {
  min-width: fit-content;
  font-size: 14px;
  color: #8c8c8c;
}

.tup {
  width: 100%;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}

.tup>img {
  width: 100%;
  /* height: 100%; */
  height: 150px;
  /* object-fit: cover; */
  object-fit: contain;
}

.kc_time {
  margin-top: 8px;
  font-size: 14px;
  color: #717C8D;
}

.kc_time+.kc_time {
  margin-top: 0;
}

.kc_t {
  margin-top: 5px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.kc_t>span:nth-child(1) {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kc_t>span:nth-child(2) {
  min-width: fit-content;
  font-size: 14px;
  color: #8c8c8c;
}

.title_box>.title>.title_downBtn{
	position: absolute;
	right: 10px;
	top: 0;
}
.fileLoadDiv >>> .el-dialog__header{
  display: none;
}
.fileLoadDiv >>> .el-dialog__body{
  display: flex;
  justify-content: center;
}
.fileLoadDiv >>> .el-dialog{
  margin-top: 60vh !important;
  width: 200px !important;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
}
.mask {
  background-color: rgb(0 0 0 / 30%);
  /* position: fixed; */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 90;
  display: flex;
  align-items: center;
  justify-content: center;
}
.progressBox {
  width: 300px;
  height: 150px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 6px 1px #bfbfbf;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  color: #6c6c6c;
}

.progressBox>>>.el-progress-bar__outer {
  background-color: #d1dfff !important;
}

.progressBox .lbox {
  height: 50px;
  font-size: 19px;
  display: flex;
  align-items: center;
  color: #747474;
}

.progressBox .lbox img {
  width: 40px;
  margin-right: 20px;
}

.boxSticky{
  position: sticky;
  top: 0;
  z-index: 999;
  background: #fff;
}

.aiBoxRight{
	height: calc(100% - 158px - 46px);
  width: 500px;
	margin: 0 auto;
	position: fixed;
  z-index: 999;
	right: 30px;
  bottom: 10px;
	box-shadow: 0 0 5px 2px #00000045;
  border-radius: 5px;
	overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/test/check/index.vue